export const common = {
emptyValue: "—",
a11y: {
goBack: "Zurück",
loading: "Wird geladen",
removePhoto: "Foto entfernen",
clearSelectedContact: "Ausgewählten Kontakt entfernen",
selectNamed: "{{name}} auswählen",
removeStep: "Schritt entfernen",
removeFilter: "Filter entfernen",
previousMonth: "Vorheriger Monat",
nextMonth: "Nächster Monat",
removeRelationship: "Beziehung entfernen",
zoomIn: "Vergrößern",
zoomOut: "Verkleinern",
resetView: "Ansicht zurücksetzen",
unlinkContact: "Kontaktverknüpfung aufheben",
removeCharge: "Gebühr entfernen",
removeLineItem: "Position entfernen",
mapUnavailable: "Karte auf diesem Gerät nicht verfügbar",
},
actions: {
  undo: "Rückgängig",
cancel: "Abbrechen",
keep: "Behalten",
search: "Suchen",
takePhoto: "Foto aufnehmen",
chooseFromGallery: "Aus Galerie wählen",
chooseFile: "Datei auswählen",
dismiss: "Schließen",
tryAgain: "Erneut versuchen",
saveChanges: "Änderungen speichern",
saving: "Wird gespeichert…",
},
createVerbs: {
guide: "Anleitung",
inspection: "Inspektion starten",
job: "Auftrag erfassen",
report: "Problem melden",
asset: "Anlage hinzufügen",
site: "Standort hinzufügen",
contact: "Kontakt hinzufügen",
share: "Anlage teilen",
template: "Checkliste erstellen",
recurringJobs: "Wartungspläne",
document: "Dokument hinzufügen",
meterReading: "Zählerstand erfassen",
maintenancePlan: "Wartungsplan hinzufügen",
knowledge: "Wissen hinzufügen",
relationship: "Beziehung hinzufügen",
assignAsset: "Anlage zuweisen",
move: "Anlage verschieben",
childSite: "Unterstandort hinzufügen",
conditionReport: "Anlagenbericht",
siteReport: "Site 360",
},
createNouns: {
  guide: "Anleitung",
  asset: "Anlage",
  inspection: "Inspektion",
  job: "Auftrag",
  report: "Mangel melden",
  maintenancePlan: "Wartung",
  contact: "Kontakt",
  site: "Standort",
  template: "Checkliste",
},
actVerbs: {
  guide: "Anleitung",
  inspection: "Prüfen",
  job: "Auftrag",
  report: "Mangel melden",
  share: "Teilen",
  document: "Dokument +",
  meterReading: "Zählerstand",
  maintenancePlan: "Plan anlegen",
  contact: "Kontakt +",
  relationship: "Verknüpfen",
  knowledge: "Artikel anlegen",
  move: "Verschieben",
  conditionReport: "Anlagenbericht",
  asset: "Anlage +",
  assignAsset: "Zuweisen",
  childSite: "Unterstandort",
  siteReport: "Site 360",
},
actVerbsA11y: {
  guide: "Anleitung für {{name}}",
  inspection: "Inspektion für {{name}} starten",
  job: "Auftrag für {{name}} erfassen",
  report: "Mangel an {{name}} melden",
  share: "{{name}} teilen",
  document: "Dokument zu {{name}} hinzufügen",
  meterReading: "Zählerstand für {{name}} erfassen",
  maintenancePlan: "Wartungsplan für {{name}} erstellen",
  contact: "Kontakt zu {{name}} hinzufügen",
  relationship: "Beziehung für {{name}} hinzufügen",
  knowledge: "Wissen zu {{name}} hinzufügen",
  move: "{{name}} verschieben",
  conditionReport: "Anlagenbericht für {{name}} erstellen",
  asset: "Anlage zu {{name}} hinzufügen",
  assignAsset: "Anlage {{name}} zuweisen",
  childSite: "Unterstandort unter {{name}} hinzufügen",
  siteReport: "Site-360-Bericht für {{name}}",
},
actionsMenuTitle: "Aktionen",
actionGroups: {
  help: "Hilfe",
  work: "Arbeit",
  record: "Erfassen",
  manage: "Verwalten",
  insight: "Einblick",
},
createFabA11y: "Erstellen — {{verbs}}",
capabilityLocked: {
tryPlanFree: "{{plan}} kostenlos testen",
  thisFeature: "Diese Funktion",
  notInCurrentPlan: "Nicht in Ihrem Tarif {{plan}} enthalten",
  notInPlan: "Nicht in Ihrem Tarif enthalten",
  includedFrom: "Enthalten ab dem Tarif {{plan}}",
  includedHigher: "In einem höheren Tarif enthalten",
  internalEdition: "Dieser Workspace nutzt die interne Developer-Edition. Schalten Sie die Funktion für Developer im Admin unter Matrix ein.",
  noPlanIncludes: "Derzeit in keinem Tarif verfügbar",
  viewPlans: "Tarife ansehen",
  openBilling: "Abrechnung & Nutzung öffnen",
  viewPlansFor: "Tarife ansehen, die {{feature}} enthalten",
  askOwner: "Bitten Sie den Eigentümer Ihres Arbeitsbereichs um ein Upgrade.",
  managedOnWeb: "Im Tarif {{plan}} verfügbar — wählen Sie ihn unter Abrechnung & Nutzung.",
  managedOnWebUnnamed: "Tarife werden unter Abrechnung & Nutzung gewählt.",
  badge: "Mit Upgrade nutzbar",
  betaTitle: "{{name}} ist in der Beta",
  betaDescription: "Treten Sie dem Beta-Programm bei, um sie vorab auszuprobieren.",
  betaAction: "Zugang anfragen",
  adminTitle: "{{name}} ist abgeschaltet",
  adminDescription: "Sie ist für diesen Arbeitsbereich abgeschaltet. Wenden Sie sich an den AssetWRX-Support, um sie zu aktivieren.",
  dependencyTitle: "{{name}} benötigt eine andere Funktion",
  dependencyDescription: "Eine Funktion, von der sie abhängt, ist abgeschaltet. Aktivieren Sie diese zuerst.",
  unavailableTitle: "{{name}} ist nicht verfügbar",
  unavailableDescription: "Diese Funktion ist für Ihren Arbeitsbereich nicht verfügbar.",
},
kpi: {
  of: "von",
  partial: "unvollständig",
},
languageNames: {
  "ar": "العربية",
  "de-DE": "Deutsch (Deutschland)",
  "en-AU": "English (Australia)",
  "en-GB": "English (UK)",
  "en-US": "English (US)",
  "es-ES": "Español (España)",
  "fr-FR": "Français (France)",
},
createMenuTitle: "Erstellen",
detailActions: {
more: "Mehr",
moreActions: "Weitere Aktionen",
short: {
inspect: "Prüfen",
addJob: "Auftrag",
issue: "Mangel melden",
share: "Teilen",
document: "Dok.",
relate: "Verknüpfen",
contact: "Kontakt",
insights: "Analysen",
},
sections: {
bringWorkIn: "Arbeit aufnehmen",
doTheWork: "Arbeit ausführen",
records: "Aufzeichnungen",
aiAndGuidance: "KI & Anleitung",
},
},
alerts: {
errorTitle: "Fehler",
requiredTitle: "Erforderlich",
permissionRequiredTitle: "Berechtigung erforderlich",
signInRequiredTitle: "Anmeldung erforderlich",
},
labels: {
id: "ID",
allTypes: "Alle Typen",
fileSelected: "Datei ausgewählt",
},
search: {
defaultPlaceholder: "Suchen",
clear: "Suche zurücksetzen",
},
searchableList: {
searchPlaceholder: "Suchen…",
clearSearch: "Suche zurücksetzen",
all: "Alle",
remove: "{{label}} entfernen",
clear: "Zurücksetzen",
noMatches: "Keine Treffer.",
more_one: "{{count}} weiterer Eintrag — grenzen Sie Ihre Suche ein, um ihn zu sehen.",
more_other: "{{count}} weitere Einträge — grenzen Sie Ihre Suche ein, um sie zu sehen.",
},
counts: {
item_one: "{{count}} Element",
item_other: "{{count}} Elemente",
mappedAssetsShowing_one: "{{count}} Anlage auf der Karte angezeigt. Ohne Koordinaten ausgeblendet: {{hidden}}.",
mappedAssetsShowing_other: "{{count}} Anlagen auf der Karte angezeigt. Ohne Koordinaten ausgeblendet: {{hidden}}.",
itemsCaptureEvidence_one: "{{count}} Punkt erfasst derzeit mindestens eine Nachweisart.",
itemsCaptureEvidence_other: "{{count}} Punkte erfassen derzeit mindestens eine Nachweisart.",
importFileSummary: "{{file}} · {{rows}} · {{columns}}",
importRows_one: "{{count}} Datenzeile",
importRows_other: "{{count}} Datenzeilen",
importColumns_one: "{{count}} Spalte",
importColumns_other: "{{count}} Spalten",
autoMapColumns_one: "{{count}} Spalte automatisch nach Name zuordnen",
autoMapColumns_other: "{{count}} Spalten automatisch nach Name zuordnen",
importPreviewRows_one: "{{shown}} von {{count}} Zeile. Gültige Zeilen zeigen genau die Werte, die importiert werden; ungültige Zeilen zeigen Fehler und die gelesenen Zellwerte.",
importPreviewRows_other: "Die ersten {{shown}} von {{count}} Zeilen. Gültige Zeilen zeigen genau die Werte, die importiert werden; ungültige Zeilen zeigen Fehler und die gelesenen Zellwerte.",
applyRows_one: "{{count}} Zeile übernehmen",
applyRows_other: "{{count}} Zeilen übernehmen",
automationsReady_one: "{{count}} Automatisierung bereit",
automationsReady_other: "{{count}} Automatisierungen bereit",
aiFollowUpsReady_one: "{{count}} KI-Entwurf für Folgearbeit bereit",
aiFollowUpsReady_other: "{{count}} KI-Entwürfe für Folgearbeit bereit",
extractedItemsFound_one: "{{count}} Position gefunden. Bearbeiten Sie sie oder wählen Sie sie ab, bevor Sie sie zum Auftrag hinzufügen.",
extractedItemsFound_other: "{{count}} Positionen gefunden. Bearbeiten Sie sie oder wählen Sie sie ab, bevor Sie sie zum Auftrag hinzufügen.",
addItems_one: "{{count}} Position hinzufügen",
addItems_other: "{{count}} Positionen hinzufügen",
},
teamMemberRole: {
owner: "Inhaber",
admin: "Admin",
member: "Mitglied",
},
teamSummary: {
memberCount_one: "{{count}} Mitglied",
memberCount_other: "{{count}} Mitglieder",
pendingInvites_one: "{{count}} offene Einladung",
pendingInvites_other: "{{count}} offene Einladungen",
expiredInvites_one: "{{count}} abgelaufene Einladung",
expiredInvites_other: "{{count}} abgelaufene Einladungen",
twoFactorOn: "2FA an",
twoFactorOff: "2FA aus",
youSuffix: "(Sie)",
skillsLoading: "Fähigkeiten: wird geladen…",
noSkills: "Keine Fähigkeiten erfasst — zum Hinzufügen tippen",
skillCount_one: "{{count}} Fähigkeit",
skillCount_other: "{{count}} Fähigkeiten",
editSkillsA11y: "Fähigkeiten von {{name}} bearbeiten",
},
teamMemberAction: {
askAdmin: "Als Admin anfragen",
changeToAdmin: "Zum Admin machen",
changeToMember: "Zum Mitglied machen",
requestSentTitle: "Anfrage gesendet",
requestSentBody: "Der Teaminhaber wird gebeten, {{name}} als Admin zu bestätigen.",
roleChangeFailed: "Rolle konnte nicht geändert werden",
removeFailed: "Mitglied konnte nicht entfernt werden",
decideFailed: "Entscheidung konnte nicht gespeichert werden",
pendingTitle: "Wartet auf Ihre Freigabe",
pendingTitleAdmin: "Wartet auf den Inhaber",
pendingRow: "{{name}} zum Admin machen? Angefragt von {{requester}}.",
approve: "Freigeben",
decline: "Ablehnen",
requestedPill: "Admin angefragt",
},
embedNotice: {
  viewOnly: "Nur ansehen: In diesem Portal können Sie Einträge ansehen, aber nicht ändern.",
  loading: "AssetWRX wird geöffnet…",
  reload: "Seite neu laden",
  expiredBody: "Die Anmeldung hat länger gedauert, als diese Seite erlaubt. Laden Sie die Seite neu, dann geht es direkt weiter.",
  expiredTitle: "Neu laden, um fortzufahren",
pageTitle: "Eingebettete Ansicht",
unsupportedTitle: "Hier nicht verfügbar",
unsupportedBody: "Dieser Teil von AssetWRX ist in dieser eingebetteten Ansicht nicht enthalten.",
goBack: "Zurück",
openInAssetWrx: "In AssetWRX öffnen",
unavailableTitle: "Einbettung ist deaktiviert",
unavailableBody: "Eingebettetes AssetWRX ist nicht im Tarif dieses Arbeitsbereichs enthalten. Bitten Sie den Inhaber Ihres AssetWRX-Arbeitsbereichs, den Tarif zu ändern.",
deniedTitle: "Diese Ansicht kann nicht geöffnet werden",
deniedBody: "Dieses Portal darf AssetWRX hier nicht für Sie öffnen. Bitten Sie Ihren AssetWRX-Administrator, die eingebettete App zu prüfen.",
endedTitle: "Sitzung beendet",
endedBody: "Diese eingebettete AssetWRX-Sitzung ist beendet. Laden Sie die Seite neu, um eine neue zu starten.",
sessionRequiredTitle: "Über Ihr Portal öffnen",
sessionRequiredBody: "Diese AssetWRX-Ansicht kann nur von einem zugelassenen Portal angezeigt werden. Öffnen Sie sie dort.",
ssoDeniedTitle: "Verwenden Sie das Konto Ihrer Organisation",
ssoDeniedBody: "Für dieses Portal müssen Sie sich mit dem Microsoft-Konto Ihrer Organisation anmelden. Laden Sie die Seite neu, um es erneut zu versuchen.",
},
tourStep: "Schritt {{current}} von {{total}}",
guideFlow: {
  pages: {
    assets: "Anlagen",
    inspections: "Prüfungen",
    requests: "Anfragen",
    jobs: "Aufträge",
    reports: "Berichte",
    contacts: "Kontakte",
    contractors: "Auftragnehmer",
  },
  ui: {
    open: "{{page}} öffnen",
    howItWorks: "So funktioniert es",
    comesInFrom: "Kommt über",
    feeds: "Führt zu {{stage}}",
    tapAgain: "Zum Öffnen nochmals tippen.",
    subtitle: "Der Alltagskreislauf von Anfang bis Ende. Zeigen oder tippen Sie auf einen Schritt und öffnen Sie dann seine Seite.",
    stageA11y: "{{num}}. {{label}}. {{caption}}. Öffnet {{page}}.",
    inputA11y: "{{label}}. Führt zu {{stage}}. Öffnet {{page}}.",
  },
  "add-your-first-asset": {
    label: "Anlagen anlegen",
    caption: "Erfassen, was Sie besitzen",
  },
  "run-an-inspection": {
    label: "Prüfen",
    caption: "Zustand & Nachweise",
  },
  "report-an-issue": {
    label: "Probleme melden",
    caption: "Jeder kann melden",
  },
  "create-a-job": {
    label: "Arbeit erledigen",
    caption: "Aufträge vergeben & verfolgen",
  },
  "share-a-report": {
    label: "Prüfen & teilen",
    caption: "Den Kreis schließen",
  },
  "public-intake-qr": {
    label: "Öffentliche QR-Meldung",
  },
  "share-for-requests": {
    label: "Geteilte Anfragende",
  },
  "add-a-contractor": {
    label: "Auftragnehmer",
  },
},
notFound: {
stackTitle: "Nicht gefunden",
title: "Seite nicht gefunden",
goHome: "Zur Startseite",
body: "Der Link ist möglicherweise veraltet oder die Seite wurde verschoben.",
},
compact: {
  minutes: "{{n}} Min.",
  hours: "{{n}} Std.",
  days: "{{n}} T.",
  now: "jetzt",
  justNow: "gerade eben",
  yesterday: "gestern",
  tomorrow: "Morgen",
},
relative: {
  today: "Heute",
  tomorrow: "Morgen",
  daysAgo: "vor {{n}} T.",
  yesterday: "Gestern",
  hoursAgo: "vor {{n}} Std.",
  minutesAgo: "vor {{n}} Min.",
  justNow: "Gerade eben",
deadlinePassed: "Frist abgelaufen",
daysLeft_one: "Noch {{count}} Tag",
daysLeft_other: "Noch {{count}} Tage",
hoursLeft_one: "Noch {{count}} Stunde",
hoursLeft_other: "Noch {{count}} Stunden",
minutesLeft_one: "Noch {{count}} Minute",
minutesLeft_other: "Noch {{count}} Minuten",
},
errors: {
  unreachable: "Der Server war nicht erreichbar. Prüfen Sie, ob Sie online sind, und versuchen Sie es dann erneut.",
  notThrough: "Das hat nicht geklappt. Bitte versuchen Sie es erneut.",
  workspaceUnavailable: "Ihr Arbeitsbereich konnte nicht geladen werden. Prüfen Sie, ob Sie online sind, und versuchen Sie es dann erneut.",
  summaryAuthorOnly: "Nur die Person, die diese Inspektion durchgeführt hat, oder ein Admin des Arbeitsbereichs kann die Zusammenfassung ändern, und nur bis zur Abnahme.",
  assetNotEditable: "Sie können eine dieser Anlagen nicht ändern.",
  templateNotEditable: "Sie können nicht ändern, mit wem diese Checkliste geteilt wird.",
  deleteApproved: "Eine genehmigte Inspektion kann nicht gelöscht werden, da sie Teil des Konformitätsnachweises ist.",
  cancelApproved: "Eine genehmigte Inspektion kann nicht storniert werden.",
  requiredItemsIncomplete: "Jeder Pflichtpunkt braucht eine Antwort oder muss übersprungen werden, bevor diese Inspektion abgeschlossen werden kann.",
  quoteRequestClosed: "Diese Angebotsanfrage ist geschlossen. Sie wurde vergeben, ihre Frist ist abgelaufen oder sie wurde zurückgezogen.",
  postcheckRequired: "Vor dem Einreichen dieses Auftrags muss eine Pflichtprüfung abgeschlossen werden.",
  evidenceRequired: "Ein Foto oder Video der fertigen Arbeit ist erforderlich. Fügen Sie es diesem Auftrag oder einem seiner Teilaufträge hinzu und versuchen Sie es erneut.",
  precheckRequired: "Vor Beginn dieses Auftrags muss eine Vorprüfung abgeschlossen werden.",
  jobHandedOff: "Dieser Auftrag wurde jemand anderem übergeben. Weisen Sie ihn neu zu oder holen Sie ihn zurück, um ihn zu ändern.",
  jobOutForQuotes: "Für diesen Auftrag werden gerade Angebote eingeholt. Wählen Sie ein Angebot oder schließen Sie die Anfrage, um ihn zu ändern.",
  inspectionHandedOff: "Diese Prüfung wurde jemand anderem übergeben. Nur diese Person kann sie beantworten.",
  retireOpenWork: "Für diese Anlage ist noch Arbeit offen. Schließen Sie sie ab oder stornieren Sie sie, bevor Sie die Anlage ausmustern.",
  templateInUseBySchedules: "Diese Checkliste wird noch von anstehenden geplanten Inspektionen verwendet. Stornieren Sie zuerst diese Planungen.",
  approveOverseerOnly: "Nur der Eigentümer, der Genehmiger oder das Team der Anlage kann diese Inspektion abnehmen, nicht der Inspektor seine eigene Arbeit.",
  waiverAdminOnly: "Nur ein Admin des Arbeitsbereichs kann eine Ausnahme für einen Befund erteilen.",
  restoreAdminOnly: "Nur ein Admin des Arbeitsbereichs kann eine ausgemusterte Anlage wiederherstellen.",
  retireOwnerOrAdmin: "Nur der Eigentümer der Anlage oder ein Admin des Arbeitsbereichs kann sie ausmustern.",
  assetRetired: "Diese Anlage wurde ausgemustert und nimmt keine neuen Inspektionen oder Aufträge mehr an.",
  workspaceReadOnly: "Dieser Arbeitsbereich ist schreibgeschützt. Wählen Sie unter Abrechnung einen Plan, um weiter hinzuzufügen und zu bearbeiten.",
  assetPlanLimit: "Das Anlagenlimit Ihres Plans ist erreicht. Ein größerer Plan ermöglicht weitere Anlagen.",
  capabilityUnavailable: "Diese Funktion ist in Ihrem Plan nicht enthalten. Wählen Sie unter Abrechnung einen Plan, um sie zu nutzen.",
  assetSubscriptionRequired: "Ihr Workspace hat die kostenlosen Anlagen seines Plans aufgebraucht. Starten Sie ein Abo, um weitere Anlagen hinzuzufügen.",
  assetChanged: "Diese Anlage wurde geändert, seit Sie sie geöffnet haben. Laden Sie sie neu und versuchen Sie es erneut.",
  onlineRequired: "Stellen Sie die Verbindung wieder her, um diese Aktion abzuschließen. Ihre Eingaben bleiben erhalten.",
  jobUpdateRefused: "Dieser Auftrag konnte von Ihrem Konto aus nicht aktualisiert werden. Er wurde möglicherweise neu zugewiesen oder geschlossen. Aktualisieren Sie und versuchen Sie es erneut.",
  jobChanged: "Dieser Auftrag wurde geändert, seit Sie ihn geöffnet haben. Laden Sie ihn neu und versuchen Sie es erneut.",
  sessionExpired: "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
  alreadyExists: "Dieses Element existiert bereits. Verwenden Sie einen anderen Wert oder bearbeiten Sie das vorhandene.",
  configMismatch: "Die App konnte diese Aktion nicht abschließen. Versuchen Sie es erneut oder wenden Sie sich an den Support, wenn es weiterhin passiert.",
  valueNotAllowed: "Einer der Werte ist nicht zulässig. Prüfen Sie Ihre Eingabe und versuchen Sie es erneut.",
  network: "Die Verbindung ist langsam oder getrennt. Bitte versuchen Sie es erneut.",
  requiredMissing: "Ein Pflichtfeld ist leer. Bitte füllen Sie alle Pflichtangaben aus.",
  noPermission: "Dazu haben Sie keine Berechtigung.",
  missingReference: "Etwas, das für diese Aktion nötig ist, wurde entfernt. Aktualisieren Sie und versuchen Sie es erneut.",
  notFound: "Dieses Element wurde nicht gefunden. Es wurde möglicherweise entfernt.",
  fallback: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
generic: "Etwas ist schiefgelaufen.",
},
resilience: {
capability_disabled: {
title: "Diese Funktion ist nicht verfügbar",
body: "Ihre Organisation hat diese Funktion nicht aktiviert. Wenden Sie sich bei Bedarf an eine Administration.",
},
permission_denied: {
title: "Keine Berechtigung",
body: "Ihre aktuelle Rolle kann diese Aktion nicht ausführen. Bestehende Arbeit wurde nicht verändert.",
},
read_only: {
title: "Schreibgeschützter Zugriff",
body: "Sie können diese Informationen ansehen, aber mit Ihrer Rolle nicht ändern.",
},
resource_unavailable: {
title: "Dieses Element ist nicht mehr verfügbar",
body: "Es wurde möglicherweise entfernt oder Ihr Zugriff hat sich geändert. Öffnen Sie Aktivitäten, um sicher fortzufahren.",
action: "Aktivitäten öffnen",
},
online_required: {
title: "Onlineverbindung erforderlich",
body: "Stellen Sie die Verbindung wieder her und versuchen Sie es erneut. Ihre Eingaben bleiben auf diesem Gerät erhalten.",
},
},
sorting: {
sortBy: "Sortieren nach",
newest: "Neueste zuerst",
oldest: "Älteste zuerst",
last_updated: "Zuletzt aktualisiert",
name_az: "Name A–Z",
name_za: "Name Z–A",
priority_high: "Priorität hoch → niedrig",
priority_low: "Priorität niedrig → hoch",
due_soonest: "Nächste Fälligkeit zuerst",
due_latest: "Späteste Fälligkeit zuerst",
overdue_first: "Überfällige zuerst",
recently_active: "Kürzlich aktiv",
status: "Status",
condition_score: "Zustandswert",
health_score: "Gesundheitswert",
risk_score: "Risikowert",
compliance_score: "Konformitätswert",
last_inspection: "Letzte Inspektion",
completed_date: "Abschlussdatum",
assigned_to: "Zugewiesen an",
scheduled_date: "Geplantes Datum",
inspection_score: "Inspektionswert",
requested_date: "Anfragedatum",
approval_status: "Genehmigungsstatus",
},
scanCapture: {
openSettings: "Einstellungen öffnen",
cameraBlockedMessage: "Der Kamerazugriff für AssetWRX ist deaktiviert. Aktivieren Sie ihn in den Einstellungen oder verwenden Sie stattdessen ein Foto.",
signInRequiredBody: "Bitte melden Sie sich an, um ein Foto mit KI zu lesen.",
aiOfflineStatus: "Das Lesen mit KI ist verfügbar, sobald Sie wieder online sind. Ihr Foto ist noch da.",
readingWithAiStatus: "Foto wird mit KI gelesen…",
couldNotReadPhotoTitle: "Foto konnte nicht gelesen werden",
tryAgain: "Bitte erneut versuchen.",
noIdentifierReadable: "Auf diesem Foto war weder Fahrgestellnummer noch Seriennummer lesbar. Versuchen Sie es erneut oder geben Sie es manuell ein.",
permissionRequiredTitle: "Berechtigung erforderlich",
grantLibraryBody: "Bitte gewähren Sie Zugriff auf die Fotobibliothek.",
readingPhotoStatus: "Foto wird gelesen…",
couldNotReadOnDeviceWeb: "Geben Sie den Wert unten ein oder lesen Sie das Foto mit KI.",
couldNotReadOnDeviceNative: "Auf diesem Gerät nicht lesbar. Geben Sie den Wert unten ein oder lesen Sie das Foto mit KI.",
enterAValueTitle: "Geben Sie einen Wert ein",
enterAValueBody: "Bitte fügen Sie einen Wert ein oder geben Sie ihn ein.",
readWithAiLabel: "Lesen Sie das Foto mit KI. Kosten {{cost}}.",
readWithAiText: "Lesen mit KI ({{cost}})",
scanQrTitle: "QR-Code scannen",
scanIdentifierTitle: "VIN/Seriennummer scannen",
webUnavailableMessage: "Kamera-Scanning ist im Web nicht verfügbar. Fügen Sie einen Wert ein oder wählen Sie ein Foto des Etiketts aus, um es zu lesen.",
identifierInputLabel: "VIN oder Seriennummer",
identifierPlaceholder: "VIN/Seriennummer einfügen oder eingeben…",
useThisValue: "Verwenden Sie diesen Wert",
pickPhotoOfLabel: "Wählen Sie ein Foto des Etiketts aus",
requestingCameraPermission: "Kameraerlaubnis wird angefordert…",
cameraPermissionRequiredTitle: "Kameraberechtigung erforderlich",
cameraPermissionMessage: "Zum Scannen ist Kamerazugriff erforderlich. Sie können auch eine Beschriftung aus einem gespeicherten Foto lesen.",
grantPermission: "Erlaubnis erteilen",
usePhotoInstead: "Verwenden Sie stattdessen ein Foto",
closeScanner: "Scanner schließen",
readingEllipsis: "Wird gelesen…",
positionQrHint: "Positionieren Sie den QR-Code im Rahmen",
positionBarcodeHint: "Zeigen Sie auf den Barcode oder tippen Sie auf den Auslöser, um das Etikett von einem Foto zu lesen",
takePhotoOfLabel: "Machen Sie ein Foto des Etiketts",
photo: "Foto",
library: "Bibliothek",
holdStill: "Ruhig halten…",
glareHint: "Blendung auf dem Schild – neigen Sie das Telefon leicht oder schatten Sie das Schild ab und versuchen Sie es erneut.",
darkHint: "Zu dunkel zum Lesen – schalten Sie das Licht ein oder suchen Sie besseres Licht und versuchen Sie es erneut.",
},
cameraControls: {
noZoom: "1×",
zoomPercent: "{{percent}} %",
zoomOut: "Herauszoomen",
zoomIn: "Hineinzoomen",
resetZoom: "Zoom zurücksetzen",
zoomValueA11y: "Zoom {{percent}} Prozent",
lightOn: "Licht einschalten",
lightOff: "Licht ausschalten",
},
cookieBanner: {
title: "Cookies auf AssetWRX",
bodyBeforeLink: "Wir verwenden Cookies, die für den Betrieb von AssetWRX unbedingt erforderlich sind. Mit Ihrer Einwilligung verwenden wir Cookies auch, um zu verstehen, wie die App genutzt wird, und um Marketingkampagnen zu messen. Sie können Ihre Meinung jederzeit ändern",
bodyCompact: "Nur notwendige Cookies, sofern Sie Analyse- und Marketing-Cookies nicht erlauben. Details in der",
cookiePolicyLink: "Cookie-Richtlinie",
rejectAll: "Alle ablehnen",
managePreferences: "Einstellungen verwalten",
acceptAll: "Alle akzeptieren",
preferencesTitle: "Cookie-Einstellungen",
strictlyNecessaryTitle: "Unbedingt erforderlich",
alwaysOn: "Immer an",
strictlyNecessaryBody: "Anmeldung, Sicherheit und Kernfunktionen.",
analyticsTitle: "Analysen",
analyticsBody: "Anonyme Nutzungsereignisse, die uns helfen, AssetWRX zu verbessern.",
marketingTitle: "Marketing",
marketingBody: "Messen Sie die Kampagnenleistung. Wir verkaufen Ihre Daten niemals.",
back: "Zurück",
savePreferences: "Einstellungen speichern",
},
analyticsPrompt: {
title: "Helfen Sie, AssetWRX zu verbessern",
body: "Teilen Sie Nutzungsdaten (die Bildschirme, die Sie verwenden, und Ihre Tipps, nie Ihre Eingaben), damit wir die App schneller und einfacher machen können. Sie können dies jederzeit unter Konto → Datenschutz & Daten → Kommunikationseinstellungen ändern.",
allow: "Erlauben",
notNow: "Nicht jetzt",
},
webContactsList: {
sort: {
name_asc: "Name A–Z",
name_desc: "Name Z–A",
updated_desc: "Zuletzt aktualisiert",
},
allRoles: "Alle",
filterByRoleA11y: "Kontakte nach Rolle filtern",
roleA11y: "Rolle: {{role}}",
moreFiltersA11y: "Weitere Filter: alle Rollentypen und Zurücksetzen",
more: "Mehr…",
visibilityScopeA11y: "Sichtbarkeitsbereich",
scopeAllA11y: "Geltungsbereich: alle",
scopeTeamA11y: "Geltungsbereich: Team",
scopeAccountA11y: "Geltungsbereich: Konto",
scopeAllLabel: "Alle Bereiche",
scopeTeamLabel: "Team",
scopeAccountLabel: "Konto",
sortContactsA11y: "Kontakte sortieren",
sortA11y: "Sortieren: {{sort}}",
importContactsA11y: "Kontakte importieren",
import: "Importieren",
columns: {
name: "Name",
scope: "Bereich",
roles: "Rollen",
organisation: "Organisation",
contact: "E-Mail / Telefon",
skills: "Fähigkeiten",
},
},
qrLabelPrint: {
defaultTitle: "Drucken Sie QR-Etiketten",
noAssetsTitle: "Keine Anlagen",
noAssetsBody: "Wählen Sie mindestens eine Anlage zum Drucken von Etiketten aus.",
noQrCodesTitle: "Keine QR-Codes",
noQrCodesBody: "Ausgewählte Anlagen haben noch keine QR-Codes.",
labelsPrepared_one: "{{count}} Etikett vorbereitet.",
labelsPrepared_other: "{{count}} Etiketten vorbereitet.",
assetsSkipped_one: "{{count}} Anlage übersprungen (QR-Code fehlt).",
assetsSkipped_other: "{{count}} Anlagen übersprungen (QR-Code fehlt).",
labelsUsedFallback_one: "{{count}} Etikett verwendete den AssetWRX-Code (keine Seriennummer hinterlegt).",
labelsUsedFallback_other: "{{count}} Etiketten verwendeten den AssetWRX-Code (keine Seriennummer hinterlegt).",
labelsReadyTitle: "Etiketten bereit",
printFailedTitle: "Druck fehlgeschlagen",
printFailedBody: "Etiketten können nicht generiert werden.",
selectedAssetsLabel: "Ausgewählte Anlagen",
selectedAssetsValue_one: "{{count}} ausgewählt ({{withQr}} mit QR-Code)",
selectedAssetsValue_other: "{{count}} ausgewählt ({{withQr}} mit QR-Code)",
templateLabel: "Checkliste",
qrContentsLabel: "QR-Inhalt",
serialCoverageNote: "{{withSerial}} von {{total}} haben eine Seriennummer; der Rest greift auf den AssetWRX-Code zurück.",
scanActionLabel: "Scan-Aktion",
includeMetadataToggle: "Fügen Sie kurze Metadaten zu Etiketten hinzu",
cancel: "Abbrechen",
printLabels: "Etiketten drucken",
},
reportReview: {
  stillToDecide_other: "{{count}} Punkte sind noch offen. Lesen Sie die Befunde unten und entscheiden Sie oben unter Ihre Entscheidungen.",
  stillToDecide_one: "{{count}} Punkt ist noch offen. Lesen Sie die Befunde unten und entscheiden Sie oben unter Ihre Entscheidungen.",
  gate: {
    notYouBody: "Sagen Sie uns, in welcher Beziehung Sie zu diesem Objekt stehen. Das zuständige Team entscheidet, ob Sie den Bericht sehen dürfen.",
    notYouLink: "Nicht die Person, an die er ging? Zugriff anfordern",
    useDifferentAccount: "Anderes Konto verwenden",
    signedInAs: "Angemeldet als {{email}}. Dieser Bericht wurde an eine andere E-Mail-Adresse gesendet.",
    notYouSignedOut: "Nicht die Person, an die er ging? Melden Sie sich an und tippen Sie auf Zugriff anfordern.",
    signedOutBody: "Wurde er Ihnen gesendet? Melden Sie sich mit der E-Mail-Adresse an, an die er ging, dann öffnet er sich sofort.",
    requestAccess: "Zugriff anfordern",
    sendFailedTitle: "Anfrage konnte nicht gesendet werden",
    roleManager: "Hausverwaltung oder Makler",
    outcomeClear: "Keine Probleme gefunden",
    outcomeAttention: "Erfordert Aufmerksamkeit",
    outcomeAction: "Handlungsbedarf",
    askSender: "Bitten Sie die Person, die ihn gesendet hat, den Link erneut zu senden.",
  },
  jobs: {
    count_other: "{{count}} Aufträge",
    count_one: "{{count}} Auftrag",
    estimatedCost: "Geschätzt: {{amount}}",
    approvedCost: "Genehmigt: {{amount}}",
    started: "Begonnen am {{date}}",
    scheduled: "Geplant am {{date}}",
    assignedTo: "Zugewiesen an {{name}}",
    cancelled: "Storniert: {{n}}",
    inProgress: "In Arbeit: {{n}}",
    completed: "Abgeschlossen: {{n}}",
  },
  done: {
    senderRepairs_other: "{{count}} Reparaturen genehmigt. Tippen Sie in der Inspektion auf Aufträge erstellen, um sie einzuplanen.",
    senderRepairs_one: "{{count}} Reparatur genehmigt. Tippen Sie in der Inspektion auf Aufträge erstellen, um sie einzuplanen.",
    repairsApproved_other: "Sie haben {{count}} Reparaturen genehmigt. Das Team wird benachrichtigt und kann daraus Aufträge machen.",
    repairsApproved_one: "Sie haben {{count}} Reparatur genehmigt. Das Team wird benachrichtigt und kann daraus einen Auftrag machen.",
    allMarked: "Alle Punkte sind als genehmigt markiert. Lehnen Sie ab, was Sie nicht möchten, unterschreiben Sie dann und tippen Sie auf Genehmigen.",
    changesRequested: "Sie haben Änderungen angefordert. {{company}} hat Ihre Anmerkung erhalten.",
    allDeclined: "Sie haben den Bericht genehmigt und alle Reparaturen abgelehnt. Das Team hat Ihre Anmerkungen.",
    approved: "Sie haben diesen Bericht genehmigt. Das Team wurde benachrichtigt.",
  },
  signOff: {
    decideFirst_other: "Erst jeden Punkt entscheiden (noch {{count}})",
    decideFirst_one: "Erst jeden Punkt entscheiden (noch {{count}})",
    sendBackPlaceholder: "Was muss geändert werden? (Pflichtfeld)",
    sendBack: "Zurücksenden",
    promptDecideFirst: "Tippen Sie zuerst oben bei jedem Punkt auf Genehmigen oder Ablehnen. Zurücksenden können Sie jederzeit.",
    promptReady: "Unterschreiben Sie, um abzuzeichnen. Das Team wird benachrichtigt und kann aus den genehmigten Reparaturen Aufträge machen.",
    promptNoItems: "Lesen Sie den Bericht. Unterschreiben Sie dann, um abzuzeichnen – oder tippen Sie auf Zurücksenden, um Änderungen anzufordern.",
    sendToTeam: "An das Team senden",
    signatureLabel: "Hier unterschreiben",
    recordsOnly: "Dieser Bericht ist für Ihre Unterlagen.",
    changesMessage: "Sie haben Änderungen angefordert",
    approvedMessage: "Sie haben dies genehmigt. Vielen Dank.",
    changesPlaceholder: "Was muss nachgebessert werden?",
    requestChanges: "Änderungen anfordern",
    approve: "Abzeichnen",
    prompt: "Prüfen Sie die Arbeit und genehmigen Sie sie oder fordern Sie Änderungen an.",
    title: "Ihre Entscheidung",
  },
  insight: {
    itemsIncluded_other: "{{count}} Punkte in diesem Bericht.",
    itemsIncluded_one: "{{count}} Punkt in diesem Bericht.",
    senderWaitingItems_other: "Warten auf die Entscheidung von {{name}} zu {{count}} Punkten.",
    senderWaitingItems_one: "Warten auf die Entscheidung von {{name}} zu {{count}} Punkt.",
    toDecide_other: "{{count}} Punkte warten auf Ihre Entscheidung, bevor Sie genehmigen.",
    toDecide_one: "{{count}} Punkt wartet auf Ihre Entscheidung, bevor Sie genehmigen.",
    sourceLabel: "den Punkten in diesem Bericht",
    actionSenderWait: "Die Person, die ihn gesendet hat, wird bei einer Antwort benachrichtigt.",
    actionTrackJobs: "Verfolgen Sie unten die Aufträge aus diesem Bericht.",
    actionApprove: "Unterschreiben Sie und tippen Sie auf Genehmigen. Das Team wird sofort benachrichtigt.",
    actionDecide: "Tippen Sie bei jedem Punkt auf Genehmigen oder Ablehnen.",
    metricNotDecided: "Offen",
    metricToDecide: "Zu entscheiden",
    checkFirst: "Vor der Entscheidung prüfen: {{list}}.",
    duplicates: "Mögliche Duplikate: {{n}}",
    noPhotos: "Ohne Fotos: {{n}}",
    urgent: "Dringend: {{n}}",
    decisionCounts: "Genehmigt: {{approved}} · Abgelehnt: {{declined}} · Offen: {{pending}}",
    senderWaiting: "Warten auf die Genehmigung von {{name}}.",
    senderChangesNoReason: "{{name}} hat Änderungen angefordert.",
    senderChanges: "{{name}} hat Änderungen angefordert: „{{reason}}“",
    senderApprovedNoDate: "{{name}} hat dies genehmigt.",
    senderApproved: "{{name}} hat dies am {{date}} genehmigt.",
    nothingToDecide: "Hier ist nichts zu entscheiden. Lesen Sie den Bericht und tippen Sie dann auf Genehmigen oder Zurücksenden.",
    youApproved: "Sie haben diesen Bericht genehmigt.",
    youApprovedOn: "Sie haben diesen Bericht am {{date}} genehmigt.",
    titleDone: "Prüfung gesendet",
    title: "Zusammenfassung der Prüfung",
  },
  threadEmptySender: "Schreiben Sie {{name}} hier. Noch keine Nachrichten.",
  threadEmptyReviewer: "Stellen Sie dem Prüfer hier Ihre Fragen. Noch keine Nachrichten.",
  inspector: "Prüfer",
  photoA11y: "Foto {{number}} von {{total}} für {{item}}",
  allDecided: "Alle Punkte sind entschieden. Unterschreiben Sie und tippen Sie auf Genehmigen.",
  decideAbove: "Entscheiden Sie oben unter Ihre Entscheidungen.",
  urgentFlagged: "Dieser Punkt ist als dringend markiert.",
  urgentNow: "Dringend – braucht sofort Aufmerksamkeit",
  recommendation: "Empfehlung",
  description: "Beschreibung",
  ratingType: {
    condition: "Zustand",
    level: "Stufe",
    passFlagFail: "Bestanden, markiert oder nicht bestanden",
    passFailNa: "Bestanden, nicht bestanden oder k. A.",
    yesNo: "Ja oder Nein",
  },
  theirDecisions: "Getroffene Entscheidungen",
  reviewerFallback: "Die prüfende Person",
  theTeam: "Das Team",
  otherGroup: "Sonstiges",
  helloGreeting: "Hallo {{name}} — {{greeting}}",
  startedOn: "Begonnen am {{date}}",
  completedOn: "Abgeschlossen am {{date}}",
  inspectionFallback: "Inspektion",
  openAssetA11y: "{{name}} öffnen",
  metaPill: "Berichtsprüfung",
  notYours: "Nur die Person, an die dieser Bericht gesendet wurde, kann ihn genehmigen oder zurücksenden.",
  saveFailed: "Ihre Auswahl konnte nicht gespeichert werden. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  evidenceFailed: "Die Befunde und Fotos konnten nicht geladen werden. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  evidenceTimeout: "Die Inspektion lädt zu lange. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
},
jobReportShare: {
  assetFallback: "Anlage",
  recipientFallback: "Empfänger",
  jobFallback: "Auftrag",
  emailSubject: "Abschlussbericht zum Auftrag – {{jobTitle}}",
headerTitle: "Bericht über den Abschluss des Arbeitsauftrags",
shareLinkNotFound: "Teilen-Link nicht gefunden.",
goToAssetWrx: "Gehen Sie zu AssetWRX",
signInToViewTitle: "Melden Sie sich an, um diesen Bericht anzuzeigen",
signInToViewBody: "Dieser Abschlussbericht zum Auftrag wurde mit Ihrer E-Mail-Adresse geteilt. Melden Sie sich an – oder erstellen Sie mit dieser E-Mail-Adresse ein kostenloses Konto – und der Bericht wird automatisch geöffnet.",
signIn: "Anmelden",
createAccount: "Konto erstellen",
noAccessOrNotFound: "Teilen-Link nicht gefunden oder Sie haben keinen Zugriff. Wenn der Bericht mit einer anderen E-Mail-Adresse geteilt wurde, melden Sie sich mit dieser Adresse an, um ihn zu öffnen.",
tryAgain: "Erneut versuchen",
loadingReport: "Bericht wird geladen…",
loadTimeout: "Das Laden des Berichts dauert zu lange. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
loadFailed: "Dieser Bericht konnte nicht geladen werden.",
},
qrScanFallback: {
linkToExistingAsset: "Mit vorhandener Anlage verknüpfen",
title: "QR-Code nicht gefunden",
message: "Der gescannte QR-Code „{{value}}...“ stimmt mit keiner vorhandenen Anlage überein.",
createNewAsset: "Neue Anlage erstellen",
createNewAssetSubtitle: "Erstellen Sie eine neue Anlage und verknüpfen Sie diesen QR-Code damit",
orLinkToExisting: "Oder mit vorhandener Anlage verknüpfen",
chooseAssetPlaceholder: "Anlage wählen",
chooseAssetHint: "Wählen Sie die Anlage aus, mit der dieser QR-Code verknüpft werden soll",
linkQrCode: "QR-Code verknüpfen",
successTitle: "Erfolg",
successBody: "QR-Code erfolgreich mit Anlage verknüpft.",
errorTitle: "Fehler",
linkFailed: "Fehler beim Verknüpfen des QR-Codes.",
},
inboxSidebar: {
  openA11y: "{{title}} öffnen",
  openAction: "Öffnen",
  snoozeFailed: "Zurückstellen hat nicht geklappt. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  snoozedUntil: "Zurückgestellt bis {{time}}. Dann erscheint es wieder.",
groupLabel: {
high: "Braucht Sie",
medium: "Neuigkeiten",
low: "Zu Ihrer Information",
read: "Gelesen",
},
inboxA11y: "Benachrichtigungen",
expandInbox: "Benachrichtigungen einblenden",
myQueue: "Benachrichtigungen",
collapseInbox: "Benachrichtigungen ausblenden",
allCaughtUp: "Alles erledigt",
noActionableNotifications: "Sie haben keine Benachrichtigungen, die etwas von Ihnen erfordern.",
itemsCountA11y_one: "{{title}}, {{count}} Eintrag",
itemsCountA11y_other: "{{title}}, {{count}} Einträge",
snoozeA11y: "{{title}} zurückstellen",
markDoneA11y: "{{title}} als erledigt markieren",
markAllRead: "Alles als gelesen markieren",
seeAllInMyQueue: "Alle Benachrichtigungen ansehen",
seeAll: "Alle anzeigen",
},
healthDetail: {
dismiss: "Schließen",
assetHealth: "Anlagenzustand",
close: "Schließen",
subtitle: "Der Betriebszustand ist eine Bewertung von 0 bis 100 aus Konformitätsdokumenten, Inspektionsplänen und -alter, offenen Arbeitsaufträgen, Genehmigungen und Inspektionsergebnissen. Eine Prüfzustandsbewertung von 1–5 wird separat gemessen.",
notScored: "Nicht bewertet",
whatChangedScore: "Was hat Ihre Punktzahl verändert?",
scoreHint: "Jede Zeile zeigt die von 100 abgezogenen Punkte, bevor die Punktzahl auf 0 bis 100 begrenzt wird.",
emptyScoreLine: "Es wird keine Bewertung angezeigt, da für diese Anlage keine abgeschlossenen Inspektionen, offenen Arbeitsaufträge, geplanten Inspektionen, Konformitätsdokumente oder offenen Anfragen vorliegen.",
noPenaltiesLine: "Keine Abzüge nach den aktuellen Regeln – die Punktzahl bleibt beim Höchstwert.",
flaggedItemsTitle: "Markierte Elemente im letzten Bericht",
openFindingA11y: "Offener Befund: {{label}}",
positiveAdjustments: "Positive Anpassungen",
recommendedActions: "Empfohlene Maßnahmen",
noActionsLine: "Keine besonderen Maßnahmen – halten Sie Inspektionen und Arbeitsaufträge auf dem neuesten Stand.",
goTo: "Gehe zu",
quickLinkJobs: "Aufträge",
quickLinkInspections: "Inspektionen",
quickLinkStartInspection: "Inspektion starten",
done: "Fertig",
},
contactInvite: {
invalidLink: "Ungültiger Einladungslink",
invitationNotFound: "Einladung nicht gefunden",
invitationExpired: "Diese Einladung ist abgelaufen",
invitationInvalid: "Dieser Einladungslink ist nicht mehr gültig.",
failedToLoad: "Die Einladung konnte nicht geladen werden",
loadTimeout: "Das Laden der Einladung dauert zu lange. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
emailMismatchTitle: "E-Mail-Konflikt",
emailMismatchBody: "Diese Einladung wurde an {{email}} gesendet. Bitte melden Sie sich mit dieser E-Mail-Adresse an, um zu akzeptieren.",
errorTitle: "Fehler",
loadingInvitation: "Einladung wird geladen…",
invalidOrExpiredTitle: "Ungültig oder abgelaufen",
tryAgain: "Erneut versuchen",
goBack: "Zurück",
title: "Kontakteinladung",
descBeforeName: "Sie wurden eingeladen, auf die App zuzugreifen als",
descAfterName: ". Dadurch wird Ihr Konto mit dem Kontakt verknüpft. Sie werden keinem Team hinzugefügt.",
signInHint: "Melden Sie sich an, um diese Einladung anzunehmen",
signIn: "Anmelden",
createAccount: "Konto erstellen",
signInWithDifferentEmailHint: "Diese Einladung wurde an {{email}} gesendet. Melden Sie sich mit diesem Konto an.",
signInWithDifferentAccount: "Melden Sie sich mit einem anderen Konto an",
accept: "Annehmen",
},
signatureField: {
defaultLabel: "Signatur",
defaultHelperText: "Tippen Sie zum Unterschreiben auf das Kästchen. Das Pad wird im Vollbildmodus geöffnet.",
clearSignature: "Unterschrift löschen",
clear: "Zurücksetzen",
signatureCapturedA11y: "Unterschrift erfasst – zum Ändern tippen",
signed: "Signiert",
tapToChange: "Zum Ändern antippen",
openSignaturePadA11y: "Zum Unterschreiben das Unterschriftenpad öffnen",
tapToSignHere: "Tippen Sie hier, um zu signieren",
signHereTitle: "Hier unterschreiben",
capturedSignatureA11y: "Erfasste Signatur",
},
invoiceCapture: {
documentLabelPdf: "PDF",
documentLabelWord: "Word",
documentLabelGeneric: "Dokument",
permissionRequiredTitle: "Berechtigung erforderlich",
grantCameraBody: "Bitte erlauben Sie den Zugriff auf die Kamera, um ein Foto aufzunehmen.",
grantLibraryBody: "Bitte gewähren Sie Zugriff auf die Fotobibliothek.",
errorTitle: "Fehler",
couldNotOpenDocumentPicker: "Die Dokumentauswahl konnte nicht geöffnet werden.",
uploadFailedTitle: "Upload fehlgeschlagen",
failedToUploadFile: "Fehler beim Hochladen der Datei.",
actionSheetTakePhoto: "Foto aufnehmen",
actionSheetChoosePhoto: "Foto auswählen",
actionSheetChooseFile: "Datei auswählen (PDF, Word)",
addInvoiceTitle: "Rechnung hinzufügen",
addInvoiceBody: "Wählen Sie Foto oder Dokument",
removeFileTitle: "Datei entfernen",
removeFileBody: "Sind Sie sicher, dass Sie diese Datei entfernen möchten?",
remove: "Entfernen",
removeInvoiceA11y: "Diese Rechnung entfernen",
addInvoiceOrReceiptA11y: "Rechnung oder Quittung hinzufügen",
},
complianceAuditDetail: {
dismiss: "Schließen",
title: "Konformität und Audit",
close: "Schließen",
subtitle: "Die Bewertung spiegelt Dokumente, Inspektionen, Zeitpläne, Arbeitsaufträge und gemeinsame Genehmigungen wider. Sie dient als Orientierung, nicht als Rechtsberatung.",
whatsAffectingScore: "Was beeinflusst Ihre Punktzahl?",
scoreHint: "Für jedes Element werden die vergebenen Punkte angezeigt, bevor die Punktzahl auf einen Wert zwischen 0 und 100 begrenzt wird.",
noScoredAdjustments: "Keine bewerteten Anpassungen – die Bewertung liegt beim Ausgangswert (100 vor der Begrenzung).",
findingsInLatestReport: "Ergebnisse im neuesten Bericht",
openFindingA11y: "Offener Befund: {{label}}",
positiveSignals: "Positive Signale",
recommendedActions: "Empfohlene Maßnahmen",
noActionsLine: "Keine spezifischen Maßnahmen – überwachen Sie weiterhin Zeitpläne und Dokumente.",
automateTitle: "Erneuerungsarbeit automatisch erstellen",
automateBody: "Wenn ein Zertifikat oder Dokument bald abläuft, wird der Erneuerungsauftrag angelegt und die richtige Person informiert.",
goTo: "Gehe zu",
quickLinkDocuments: "Dokumente",
quickLinkInspections: "Inspektionen",
quickLinkJobs: "Aufträge",
done: "Fertig",
},
videoCapture: {
permissionRequiredTitle: "Berechtigung erforderlich",
permissionMessage: "Bitte gewähren Sie {{type}} Zugriff, um fortzufahren.",
cameraAccessType: "Kamera",
photoLibraryAccessType: "Fotobibliothek",
videoTooLongTitle: "Video zu lang",
videoTooLongBody: "Videos dürfen höchstens {{max}} Sekunden lang sein. Dieses Video ist {{actual}} Sekunden lang.",
couldNotAddVideoTitle: "Video konnte nicht hinzugefügt werden",
failedToAddVideo: "Video konnte nicht hinzugefügt werden. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
addVideoTitle: "Video hinzufügen",
chooseAnOption: "Wählen Sie eine Option",
recordVideo: "Video aufnehmen",
chooseFromLibrary: "Aus der Bibliothek auswählen",
videoLimitReachedTitle: "Videolimit erreicht",
videoLimitReachedBody_one: "Hier können Sie bis zu {{count}} Video anhängen. Entfernen Sie eines, um ein weiteres hinzuzufügen.",
videoLimitReachedBody_other: "Hier können Sie bis zu {{count}} Videos anhängen. Entfernen Sie eines, um ein weiteres hinzuzufügen.",
removeVideoTitle: "Video entfernen",
removeVideoBody: "Möchten Sie dieses Video wirklich entfernen?",
playVideoA11y: "Video abspielen {{index}}",
videoPreviewA11y: "Video {{index}} Vorschau",
videoLabel: "Video {{index}}",
removeVideoA11y: "Video entfernen {{index}}",
addVideoLabel: "Video hinzufügen",
},
signatureCaptureModal: {
defaultHelperText: "Unterschreiben Sie mit Ihrem Finger oder Ihrer Maus und tippen Sie dann auf „Fertig“.",
cancelSigningA11y: "Signieren abbrechen",
saveSignatureA11y: "Signatur speichern",
done: "Fertig",
},
conversationThread: {
defaultEmptyHint: "Noch keine Nachrichten. Beginnen Sie das Gespräch.",
updates: "Neuigkeiten",
updatesWithName: "Updates mit {{name}}",
earlier: "Früher",
earlierA11y: "Frühere 100 Nachrichten",
newer: "Neuer",
newerA11y: "Neuere 100 Nachrichten",
latest: "Neueste",
latestA11y: "Neueste Nachrichten",
loadingMessages: "Nachrichten werden geladen…",
messagesUnavailable: "Nachrichten sind derzeit nicht verfügbar.",
noMessagesInThisPart: "Keine Nachrichten in diesem Teil der Konversation.",
startAnUpdatePlaceholder: "Ein Update starten…",
messageA11y: "Nachricht",
sendMessageA11y: "Nachricht senden",
couldNotSendMessage: "Nachricht konnte nicht gesendet werden.",
failedToSend: "Fehler beim Senden",
},
guideArticle: {
userGuideTitle: "Benutzerhandbuch",
helpTitle: "Hilfe",
articleNotFound: "Artikel nicht gefunden",
whyItMatters: "Warum es wichtig ist",
showMe: "Zeigen Sie es mir",
howToDoIt: "Wie es geht",
whatToDoNext: "Nächste Schritte",
},
webQuickCreateMenu: {
quickCreateA11y: "Schnell erstellen",
quickCreate: "Schnell erstellen",
},
ownershipTransfer: {
aTeamMemberFallback: "ein Teammitglied",
couldNotUpdateTitle: "Die Übertragung konnte nicht aktualisiert werden",
tryAgain: "Bitte erneut versuchen.",
doneTitle: "Fertig",
offerLapsesSuffix: " Das Angebot verfällt am {{date}}.",
offeredOwnershipTitle: "Ihnen wurde der Besitz von {{teamName}} angeboten",
offeredOwnershipBody: "{{initiatorName}} möchte das Team an Sie übergeben. Als Eigentümer verwalten Sie Mitglieder-, Abrechnungs- und Arbeitsbereichseinstellungen. {{initiatorName2}} wird Administrator.",
acceptOwnership: "Inhaberschaft annehmen",
nowOwnTeam: "Sie besitzen jetzt {{teamName}}.",
decline: "Ablehnen",
declinedOffer: "Sie haben das Angebot abgelehnt.",
waitingForAcceptTitle: "Warten darauf, dass {{targetName}} den Besitz akzeptiert",
waitingForAcceptBody: "Es ändert sich nichts, bis sie akzeptieren. Sie bleiben in der Zwischenzeit Eigentümer.",
cancelOffer: "Angebot stornieren",
offerWithdrawn: "Das Angebot wurde zurückgezogen.",
},
routeError: {
title: "Bei diesem Bildschirm ist ein Problem aufgetreten",
body: "Der Rest der App läuft noch und Ihre Offline-Arbeit in der Warteschlange ist sicher. Versuchen Sie es erneut oder gehen Sie zurück und öffnen Sie diesen Bildschirm erneut.",
referenceLabel: "Referenz: {{referenceId}}",
tryAgain: "Erneut versuchen",
goBack: "Zurück",
},
photoAttachButton: {
couldNotAddPhotoTitle: "Foto konnte nicht hinzugefügt werden",
pleaseTryAgain: "Bitte erneut versuchen.",
permissionRequiredTitle: "Berechtigung erforderlich",
permissionMessage: "Bitte gewähren Sie {{type}} Zugriff, um fortzufahren.",
cameraAccessType: "Kamera",
photoLibraryAccessType: "Fotobibliothek",
addPhotoTitle: "Foto hinzufügen",
addPhotoBody: "Fügen Sie das Foto unverändert hinzu oder zeichnen Sie zuerst, um Bereiche hervorzuheben.",
addNow: "Jetzt hinzufügen",
photoAdded: "Foto hinzugefügt",
drawToHighlight: "Zum Hervorheben zeichnen",
addPhotoOptionsTitle: "Foto hinzufügen",
chooseAnOption: "Wählen Sie eine Option",
camera: "Kamera",
photoLibrary: "Fotobibliothek",
attachPhotoA11y: "Foto anhängen",
},
qrResolver: {
lookupTimedOut: "Zeitüberschreitung bei der QR-Suche.",
resolvingQrCode: "QR-Code wird aufgelöst...",
scannedAssetTitle: "Sie haben eine Anlage gescannt",
scannedAssetBody: "Dieser Code gehört zu einer in AssetWRX verwalteten Anlage. Wählen Sie, was Sie tun möchten.",
scannedAssetBodySignInOnly: "Dieser Code gehört zu einer in AssetWRX verwalteten Anlage. Melden Sie sich an, um sie zu sehen.",
reportAnIssue: "Ein Problem melden",
reportAnIssueA11y: "Melden Sie ein Problem mit dieser Anlage – kein Konto erforderlich",
signInToView: "Melden Sie sich an, um es anzuzeigen",
signInToViewA11y: "Melden Sie sich an, um diese Anlage anzuzeigen",
},
teamSwitcher: {
teamFallback: "Team",
personal: "Persönlich",
switchTeam: "Team wechseln",
cancel: "Abbrechen",
},
requiredSkillsPicker: {
defaultLabel: "Kenntnisse erforderlich",
couldNotLoad: "Fertigkeiten konnten momentan nicht geladen werden.",
couldNotRefresh: "Fertigkeiten konnten nicht aktualisiert werden. Versuchen Sie es erneut.",
requiredTitle: "Erforderliche Fähigkeiten",
skillsTitle: "Fähigkeiten",
requiredHint: "Wählen Sie eine oder mehrere Fähigkeiten aus. Mindestens eine ist erforderlich.",
optionalHint: "Wählen Sie eine oder mehrere Fähigkeiten aus Ihrem Katalog aus (optional).",
mustHaveTag: " · ein Muss",
removeSkillA11y: "{{name}} entfernen",
changeRequiredSkills: "Erforderliche Fähigkeiten ändern",
selectAtLeastOne: "Wählen Sie mindestens eine erforderliche Fähigkeit aus",
addSkillsOptional: "Fertigkeiten hinzufügen (optional)",
mandatoryHint: "Markieren Sie eine Fähigkeit als „Ein Muss“, und niemand ohne diese Fähigkeit wird für diese Arbeit vorgeschlagen. Wer die übrigen hat, wird nur weiter oben gelistet.",
searchSkillsA11y: "Fähigkeiten suchen",
searchSkillsPlaceholder: "Fähigkeiten suchen...",
loadingSkills: "Fertigkeiten werden geladen...",
noSkillsFound: "Noch keine Fähigkeiten gefunden. Fügen Sie Fähigkeiten in den Auftragnehmereinstellungen hinzu.",
noSkillsMatch: "Keine Fähigkeiten entsprechen Ihrer Suche.",
removeSkillRowA11y: "{{name}} entfernen",
addSkillRowA11y: "{{name}} hinzufügen",
mustHaveOnA11y: "{{name}} ist ein Muss. Machen Sie es stattdessen zu Ihrer Präferenz.",
mustHaveOffA11y: "Machen Sie {{name}} zu einem Muss für diese Arbeit",
mustHave: "Ein Muss",
done: "Fertig",
},
reportingPage: {
executiveSummary: "Zusammenfassung",
supportingDetail: "Unterstützendes Detail",
whatChanged: "Was hat sich geändert?",
whyItMatters: "Warum es wichtig ist",
action: "Aktion",
hideReportStatements: "Berichtsaussagen ausblenden",
showReportStatements: "Berichtsaussagen und unterstützende Zeilen anzeigen",
sourceLabel: "die Aufzeichnungen dieses Berichts",
},
refineSheet: {
defaultTitle: "Filtern",
activeFilters_one: "{{count}} aktiver Filter",
activeFilters_other: "{{count}} aktive Filter",
noActiveFilters: "Keine aktiven Filter",
reset: "Zurücksetzen",
doneA11y: "Fertig",
done: "Fertig",
},
qrCodeDisplay: {
noQrCode: "Kein QR-Code verfügbar",
copyErrorTitle: "Fehler",
copyErrorBody: "Fehler beim Kopieren des QR-Code-Links.",
shareMessageWithName: "Anlagen-QR-Code für {{name}}: {{url}}",
shareMessageNoName: "Anlagen-QR-Code: {{url}}",
copied: "Kopiert",
copyLink: "Link kopieren",
share: "Teilen",
},
jobCard: {
urgencyLow: "Niedrig",
urgencyMedium: "Mittel",
urgencyHigh: "Hoch",
urgencyCritical: "Kritisch",
scheduledFallback: "Geplant",
dueDate: "Fällig am {{date}}",
createdToday: "Heute erstellt",
createdDate: "Erstellt {{date}}",
rejectedFallback: "Abgelehnt",
rejectedWithReason: "Abgelehnt: {{reason}}",
unassigned: "Nicht zugewiesen",
newUpdate: "Neues Update",
updatedAt: "{{when}} aktualisiert",
skillCount_one: "{{count}} Fähigkeit",
skillCount_other: "{{count}} Fähigkeiten",
a11yJob: "Arbeitsauftrag: {{title}}",
a11yAsset: "Anlage: {{name}}",
a11yStatus: "Status: {{status}}",
a11yPriority: "Priorität: {{priority}}",
a11yCategory: "Kategorie: {{category}}",
a11yAssignee: "Zuständige Person: {{name}}",
a11ySchedule: "Zeitplan: {{when}}",
a11yActivity: "Aktivität: {{activity}}",
a11yAttentionOverdue: "Achtung: Überfällig",
a11yAttentionUnscheduled: "Achtung: Nicht eingeplant",
openAssetA11y: "Öffnen Sie die Anlage {{name}}",
detailsFallback: "Details",
noAsset: "Keine Anlage",
followOnPending: "Folgeauftrag steht aus",
overdue: "Überfällig",
unscheduled: "Nicht geplant",
followOnPendingApproval: "Folgeauftrag · Genehmigung steht noch aus",
priorityColumnHint: "Priorität",
assigneeColumnHint: "Zuständige Person",
dueScheduleColumnHint: "Fällig / Zeitplan",
typeColumnHint: "Typ",
},
healthCard: {
assetHealth: "Anlagenzustand",
noInspectionsYet: "Noch keine Prüfungen",
viewOpenJobsInWork: "Offene Arbeitsaufträge in „Arbeit“ anzeigen",
startInspectionInWork: "Starten Sie die Inspektion in „Arbeit“.",
viewHealthBreakdown: "Zustandsaufschlüsselung anzeigen",
lastInspected: "Zuletzt geprüft {{date}}",
},
failedSyncRecovery: {
defaultTitle: "Konnte nicht synchronisiert werden",
dismiss: "Schließen",
copyError: "Fehler kopieren",
retrySync: "Synchronisierung erneut versuchen",
},
conflictResolution: {
title: "Jemand anderes hat diese Inspektion geändert",
body: "Jemand hat diese Inspektion gespeichert, während einige Ihrer Antworten noch nicht gespeichert waren. Ihre Antworten bleiben auf diesem Gerät, bis Sie sich entscheiden.",
mergeAndSync: "Meine Antworten behalten",
useLatestFromServer: "Andere Version übernehmen",
hint: "Mit „Andere Version übernehmen“ werden Ihre nicht gespeicherten Antworten von diesem Gerät entfernt.",
decideLater: "Entscheiden Sie später",
},
evidenceCapture: {
defaultDocumentSectionLabel: "Dokumente",
media: "Medien",
addPhotoOrVideoA11y: "Fügen Sie ein Foto oder Video hinzu",
addPhotoA11y: "Fügen Sie ein Foto hinzu",
addVideoA11y: "Fügen Sie ein Video hinzu",
noMediaAttached: "Keine Medien angehängt",
hintPhoto_one: "Bis zu {{count}} Foto",
hintPhoto_other: "Bis zu {{count}} Fotos",
hintVideoWithPrefix_one: "Bis zu {{count}} Video",
hintVideoWithPrefix_other: "Bis zu {{count}} Videos",
hintVideoNoPrefix_one: "{{count}} Video",
hintVideoNoPrefix_other: "{{count}} Videos",
hintVideoDurationSuffix: ", max. {{seconds}}s",
addEvidence: "Nachweis hinzufügen",
takeAPhoto: "Machen Sie ein Foto",
chooseAPhoto: "Wählen Sie ein Foto",
recordAVideo: "Nehmen Sie ein Video auf",
chooseAVideo: "Wählen Sie ein Video",
},
localComplianceRead: {
clearRead: "Gelesene Werte löschen",
checkThis: "Überprüfen Sie dies",
confirm: "Bestätigen",
certificateNumber: "Zertifikatsnummer",
nextDue: "Nächster Fälligkeitstermin",
result: "Ergebnis",
readingOnDevice: "Dokument wird auf diesem Gerät gelesen…",
useCertificateNumber: "Verwenden Sie die Zertifikatsnummer {{value}}",
useNextDueDate: "Nächstes Fälligkeitsdatum verwenden {{value}}",
title: "Aus diesem Dokument gelesen",
dismissA11y: "Gelesene Werte des Dokuments verwerfen",
readOnDeviceNoCredits: "Auf diesem Gerät gelesen – es wurden keine KI-Credits verwendet.",
use: "Verwenden",
},
planPicker: {
trial: "{{days}} Tage kostenlos testen, dann {{price}}",
adds: "Zusätzlich: {{list}}",
  titleLimit: "Upgrade für mehr Anlagen",
  titleChange: "Wählen Sie Ihren Plan",
  titleUnlock: "{{feature}} freischalten",
  checkoutFailedTitle: "Bezahlvorgang konnte nicht gestartet werden",
  introLimit: "Wählen Sie einen Plan, um weitere Anlagen hinzuzufügen und mehr Funktionen freizuschalten. Verbleibende kostenlose Zeit wird übernommen.",
  introChange: "Ihr Plan legt fest, welche Funktionen verfügbar sind. Anlagen und KI-Credits werden separat abgerechnet.",
  loading: "Pläne werden geladen…",
  unavailable: "Die Pläne konnten nicht geladen werden. Versuchen Sie es später erneut.",
  notNow: "Jetzt nicht",
  current: "Aktuell",
yourPlan: "Ihr Plan",
payFor: "{{name}} bezahlen",
renew: "{{name}} verlängern",
  priceFree: "Kostenlos",
  priceTalkToUs: "Sprechen Sie mit uns",
  priceFromPerAsset: "Ab {{price}}/Anlage/Monat",
  priceFeePlusAssets: "{{price}}/Monat + pro Anlage",
  priceFeeOnly: "{{price}}/Monat",
  priceAnnualPlusAssets: "{{price}}/Jahr + pro Anlage",
  priceAnnualOnly: "{{price}}/Jahr",
  continueWith: "Weiter mit {{name}}",
  contactSales: "Vertrieb kontaktieren",
  managedOnWeb: "In der App nicht kaufbar",
  otherPlans: "Weitere Pläne",
  webOnly: "Pläne und Credits werden unter Abrechnung & Nutzung gewählt.",
},
storePlans: {
  title: "In der App abonnieren",
  loading: "Tarife werden geladen…",
  unavailable: "Abonnements sind gerade nicht verfügbar. Versuchen Sie es später erneut.",
  perMonth: "{{price}} pro Monat",
  perYear: "{{price}} pro Jahr",
  subscribe: "Abonnieren",
  working: "Wird bearbeitet…",
  restore: "Käufe wiederherstellen",
  activating: "Ihr Tarif wird aktiviert…",
  pending: "Ihr Kauf war erfolgreich. Ihr Tarif wird gleich aktualisiert. Tippen Sie unter Abrechnung & Nutzung auf Aktualisieren.",
  manage: "Abonnement verwalten",
  billedElsewhere: "Das Abonnement dieses Workspaces wird außerhalb dieser App abgerechnet.",
  termsIos: "Die Zahlung wird bei Bestätigung Ihrer Apple-ID belastet. Das Abonnement verlängert sich automatisch, sofern es nicht mindestens 24 Stunden vor Ende des aktuellen Zeitraums gekündigt wird. Verwalten oder kündigen Sie es in Ihren App-Store-Kontoeinstellungen.",
  termsAndroid: "Die Zahlung wird bei Bestätigung Ihrem Google-Konto belastet. Das Abonnement verlängert sich automatisch, sofern es nicht vor Ende des aktuellen Zeitraums gekündigt wird. Verwalten oder kündigen Sie es unter Google-Play-Abos.",
  termsOfUse: "Nutzungsbedingungen",
  privacyPolicy: "Datenschutzerklärung",
},
planLimit: {
subscriptionRequiredTitle: "Planlimit erreicht",
nextAssetNeedsPlan: "Sie haben die kostenlosen Anlagen Ihres Plans genutzt. Die nächste braucht einen bezahlten Plan.",
assetsUsed: "{{used}} von {{limit}} Anlagen Ihres Plans.",
checkoutUnavailableTitle: "Der Kauf ist hier noch nicht möglich",
checkoutUnavailableBody: "Pläne können aus dieser Version nicht gekauft werden. Kontaktieren Sie uns, wir richten es für Sie ein.",
memberBodyCreate: "Ihr Workspace hat das Anlagenlimit seines Plans erreicht. Ein Workspace-Admin muss einen Plan wählen, bevor eine weitere aktive Anlage hinzugefügt werden kann.",
memberBodyImport: "Ihr Workspace hat das Anlagenlimit seines Plans erreicht. Ein Workspace-Admin muss einen Plan wählen, bevor weitere Anlagen importiert werden können.",
  title: "Tariflimit erreicht",
  notNow: "Nicht jetzt",
  seePlans: "Tarife ansehen",
  perAsset: "Pro Anlage",
  limit: "Anlagenlimit: {{count}}",
},
/** Field sync states (lib/fieldSync/contract.ts is the English contract; a test keeps en-US equal to it). */
fieldSync: {
local_draft: {
label: "Lokal gespeichert",
message: "Auf diesem Gerät gespeichert — wird automatisch synchronisiert, sobald Sie wieder online sind.",
},
pending_sync: {
label: "Wird synchronisiert",
message: "Ihre Änderungen werden synchronisiert…",
},
synced: {
label: "Synchronisiert",
message: "Alle Änderungen synchronisiert.",
},
failed_sync: {
label: "Braucht Aufmerksamkeit",
message: "Diese Änderung konnte nicht gespeichert werden — Ihre Arbeit ist auf diesem Gerät sicher. Zum Wiederholen tippen.",
messageWithDetail: "Speichern fehlgeschlagen: {{detail}} Zum Wiederholen tippen.",
},
conflict_review: {
label: "Braucht Aufmerksamkeit",
message: "Jemand anderes hat dies aktualisiert — bitte vor dem Speichern kurz prüfen.",
},
online_required: {
label: "Online erforderlich",
message: "Stellen Sie die Verbindung wieder her, um diese Aktion abzuschließen. Ihre Eingaben bleiben erhalten.",
},
},
editionPlanSection: {
contactSalesTitle: "Kontaktieren Sie den Vertrieb",
contactSalesBody: "Senden Sie eine E-Mail an {{email}}, um den Tarif {{plan}} zu besprechen.",
notSet: "Nicht gesetzt",
customPricing: "Individuelle Preise",
noCharge: "Keine Kosten",
changePlan: "Plan ändern",
chooseAPlan: "Wählen Sie einen Plan",
changeTitle: "Zu {{name}} wechseln?",
changeBody: "Ein größerer Tarif gilt sofort, und die Differenz für den Rest dieses Abrechnungszeitraums wird heute berechnet. Ein kleinerer Tarif oder Free gilt ab Ihrem Verlängerungsdatum; bis dahin ändert sich nichts.",
scheduledTitle: "Tarifwechsel vorgemerkt",
scheduledBody: "Ihr Tarif wechselt am {{date}} zu {{name}}. Bis dahin behalten Sie Ihren aktuellen Tarif. Wählen Sie Ihren aktuellen Tarif erneut, um den Wechsel abzubrechen.",
changeConfirm: "Wechseln",
changeCancel: "Nicht jetzt",
billMonthly: "Monatlich",
billYearly: "Jährlich",
billingTerm: "Abrechnung",
},
legalDoc: {
unknownDocument: "Unbekanntes Dokument.",
loadFailed: "Dieses Dokument konnte nicht geladen werden. Bitte versuchen Sie es in Kürze noch einmal.",
versionLabel: "Version {{version}}",
effectiveLabel: "Gültig ab {{date}}",
titleFallback: "Rechtliches",
loading: "Wird geladen…",
errorTitle: "Fehler",
documentNotFound: "Dokument nicht gefunden.",
},
notificationRecovery: {
title: "Benachrichtigung",
safeRecovery: "Sichere Wiederherstellung",
},
actionSheet: {
cancelA11y: "Abbrechen",
cancel: "Abbrechen",
},
actionPopover: {
closeCreateMenuA11y: "Erstellungsmenü schließen",
},
fieldModeToggle: {
fieldModeA11y: "Feldmodus",
fieldModeHint: "Erhöht den Kontrast und die Touch-Ziele für den Außenbereich",
fieldMode: "Feldmodus",
},
appErrorBoundary: {
title: "Etwas ist schiefgelaufen",
body: "AssetWRX hat den Fehler erfasst. Sie können diesen Bildschirm erneut versuchen, ohne dass Offline-Arbeiten in der Warteschlange verloren gehen.",
retry: "Wiederholen",
},
profileAvatar: {
profileAvatarA11y: "Profil-Avatar",
profileInitialsA11y: "Profilinitialen",
},
nativeDateTimePicker: {
selectDate: "Datum wählen",
selectTime: "Uhrzeit auswählen",
cancelSelectionA11y: "{{mode}}-Auswahl aufheben",
cancel: "Abbrechen",
confirmA11y: "Bestätigen Sie {{mode}}",
done: "Fertig",
},
assetMapView: {
basemapStreets: "Straßen",
basemapSatellite: "Satellit",
basemapTopographic: "Topografisch",
overlayClusters: "Clustergruppierung",
overlayHeatmap: "Dichte-Heatmap",
overlaySelectionHighlight: "Auswahlhervorhebung",
threeDCameraTilt: "3D-Kameraneigung",
threeDTerrainRelief: "3D-Geländerelief",
hideMapOptionsA11y: "Kartenoptionen ausblenden",
basemapA11y: "Grundkarte: {{name}}",
mapOptionsA11y: "Kartenoptionen",
rendererUnavailable: "Kartenrenderer auf diesem Gerät nicht verfügbar.",
},
uiCopy: {
  checkAnswerNotSavedTitle: "Diese Antwort konnte nicht gespeichert werden",
  checkLoadFailed: "Diese Prüfung konnte nicht geladen werden.",
  fieldAssist: {
    tryAgain: "Bitte versuchen Sie es erneut.",
    revert: "Zurücksetzen",
    discard: "Verwerfen",
    accept: "Übernehmen",
    suggestedTitle: "Vorgeschlagener Text",
    dictate: "Diktieren",
    stop: "Beenden",
  },
markAllNotificationsAsRead_2777a0: "Alle Benachrichtigungen als gelesen markieren",
retrySearch_eed38a: "Wiederholen Sie die Suche",
importAssetsFromSpreadsheet_319028: "Anlagen aus Tabellenkalkulation importieren",
filterBySite_cf1cee: "Nach Standort filtern",
couldntLoadYourAssets_9878ab: "Ihre Anlagen konnten nicht geladen werden",
yourAssetsAreStillThereCheckYour_f01439: "Ihre Anlagen sind noch vorhanden. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
loadingRelationshipView_b7eaea: "Beziehungsansicht wird geladen…",
noMappedAssetsYet_6f573a: "Noch keine zugeordneten Anlagen.",
saveCoordinatesOnAnAssetToEnable_da096f: "Speichern Sie Koordinaten auf einer Anlage, um die Kartenansicht zu aktivieren.",
mapUnavailableRightNow_d6091e: "Karte derzeit nicht verfügbar.",
theAssetListStillWorksNormally_b8aeb7: "Die Anlagenliste funktioniert weiterhin normal.",
loadingMap_8f267a: "Karte wird geladen…",
assignSite_e1d79b: "Standort zuweisen",
assignToSite_5f6e86: "Einem Standort zuweisen",
contactInsight_51a9e3: "Kontakteinblick",
findContactsSkills_f8dc04: "Kontakte suchen",
refineContactFilters_fa9072: "Kontakte filtern",
importContactsFromAFileOrYour_210d87: "Importieren Sie Kontakte aus einer Datei oder Ihrem Gerät",
refineContacts_982f6f: "Kontakte filtern",
opensFiltersToChangeWhichContactsAre_304ff8: "Öffnet Filter, um zu ändern, welche Kontakte angezeigt werden.",
chooseAContactToSeeSharedAssets_8202a6: "Wählen Sie einen Kontakt aus, um freigegebene Anlagen, Anfragen und zugehörige Arbeiten anzuzeigen, ohne diese Seite zu verlassen.",
noContactDetailsOnFile_131e9d: "Keine Kontaktdaten hinterlegt",
noLinkedSkills_16d322: "Keine verknüpften Fertigkeiten",
noOpenJobsForThisContact_4857c4: "Keine offenen Arbeitsaufträge für diesen Kontakt",
historyNotes_83ccc2: "Verlauf und Notizen",
couldntRefreshYourWorkShowingWhatWas_8e2372: "Ihre Arbeit konnte nicht aktualisiert werden – es wird angezeigt, was zuletzt geladen wurde. Tippen Sie, um es noch einmal zu versuchen.",
generateAdvancedReport_7e5def: "Erweiterten Bericht erstellen",
buildsAFullReportUsingInspectionsJobs_bfa133: "Erstellt einen vollständigen Bericht anhand von Inspektionen, Arbeitsaufträgen, Dokumenten, Risikodaten, Wartungshistorie und optionaler Internetrecherche.",
advancedReportInsight_a02085: "Erweiterte Berichtseinblicke",
noAdvancedReportGeneratedYet_59d1d4: "Es wurde noch kein erweiterter Bericht erstellt.",
fillInDetailsToSeeAPreview_84bd8b: "Geben Sie die Details ein, um hier eine Vorschau zu sehen.",
assetNameRequired_06d7dc: "Anlagenname (erforderlich)",
suggestedIdentity_36046f: "Vorgeschlagene Identität",
dismissIdentitySuggestion_f3e055: "Identitätsvorschlag verwerfen",
identifyTheAssetTypeFromThePhoto_d205fa: "Identifizieren Sie den Anlagentyp anhand des Fotos mithilfe von KI",
identifiedFromPhoto_c90812: "Identifiziert anhand des Fotos",
applyTheIdentifiedAssetType_a066ab: "Wenden Sie den identifizierten Anlagentyp an",
applyType_00972d: "Typ anwenden",
dismissPhotoIdentity_a1052e: "Fotoidentität verwerfen",
inServiceToday_7a4392: "Heute im Einsatz?",
yesInUse_0e9408: "Ja, im Einsatz",
notYet_8de95f: "Noch nicht",
qRCodeWillBeLinkedAfterCreation_87a9e9: "QR-Code wird nach der Erstellung verknüpft",
matchMyNearestSite_4d4d97: "Nächstgelegenen Standort zuordnen",
tapToAddYourFirstPhoto_7f8b7c: "Tippen Sie hier, um Ihr erstes Foto hinzuzufügen",
gallery_9c30a3: "Galerie",
removeAllPhotos_6c3c73: "Alle Fotos entfernen",
iDSerialOptional_25584f: "ID/Seriennummer (optional)",
thisReferenceLinksIoTDevicesAndAPI_4f5ce4: "Diese Referenz verknüpft IoT-Geräte und API-Ereignisse mit dieser Anlage.",
scanIDOrSerial_956e65: "ID oder Seriennummer scannen",
readFromPhoto_ee811f: "Vom Foto lesen",
relationshipsOptional_df493d: "Beziehungen (optional)",
vehicleType_964438: "Fahrzeugtyp",
fuelType_0e58d4: "Kraftstofftyp",
usage_0bb186: "Verwendung",
propertyType_8ad7ea: "Immobilienart",
occupancy_570235: "Belegung",
equipmentType_d92829: "Gerätetyp",
powerSource_56547a: "Stromquelle",
installation_c81b79: "Einbau",
whereIsThisAssetInItsLife_ffff43: "Wo befindet sich diese Anlage in ihrem Lebenszyklus?",
criticalityOptional_491f40: "Kritikalität (optional)",
howCriticalIsThisAssetToOperations_04df20: "Wie wichtig ist diese Anlage für den Betrieb?",
operatingContextOptional_178f94: "Betriebskontext (optional)",
complianceTagsOptional_2df1fc: "Konformitäts-Tags (optional)",
identifyAndTag_f946d5: "Identifizieren und markieren",
addMoreNowOrAnytimeLater_3eac61: "Fügen Sie jetzt oder jederzeit später weitere hinzu.",
potentialDuplicatesDetected_4b9918: "Potenzielle Duplikate erkannt",
moreOptions_0a1b2c: "Weitere Optionen",
reviewMatchingAssetsBeforeCreatingANew_90559b: "Überprüfen Sie übereinstimmende Anlagen, bevor Sie einen neuen Datensatz erstellen.",
useExistingAsset_3f06d4: "Vorhandene Anlage verwenden",
openExisting_941fb8: "Vorhandenes öffnen",
continueAnyway_011856: "Trotzdem fortfahren",
createLinkPossibleDuplicate_e5dcab: "Mögliches Duplikat erstellen + verknüpfen",
markIntentionallyDistinct_cc3540: "Als bewusst eigenständig markieren",
subtype_a729bb: "Art des Dokuments",
loadingAsset_a104a6: "Anlage wird geladen",
retryLoadingAsset_544af8: "Versuchen Sie erneut, die Anlage zu laden",
onlyTheAssetsOwnerOrItsTeam_95113f: "Nur der Eigentümer der Anlage oder sein Team kann sie bearbeiten. Sie können sie weiterhin ansehen und Arbeit dafür anlegen.",
basicDetails_42450f: "Grundlegende Details",
photosOptional_c0ea6e: "Fotos (optional)",
removeAllPhotos_1329e0: "Alle Fotos entfernen",
egToyotaCamry2024_d36609: "z.B. Toyota Camry 2024",
locationNotes_259645: "Standort und Notizen",
addDetailsAboutThisAsset_ec093a: "Details zu dieser Anlage hinzufügen...",
identifiers_649d28: "Bezeichner",
importAssets_9158f1: "Anlagen importieren",
invalidSharedAssetLink_1f7b4c: "Ungültiger freigegebener Anlagenlink.",
sharedAsset_80c5e0: "Gemeinsame Anlage",
checkingAccess_c5108c: "Zugriff wird überprüft…",
signInWithTheAccountThatWas_5dd47c: "Melden Sie sich mit dem Konto an, das als Kontakt eingeladen wurde, um direkt mit dieser freigegebenen Anlage fortzufahren.",
signInToViewThisSharedAsset_c8d337: "Melden Sie sich an, um diese freigegebene Anlage anzuzeigen",
createAnAccountToViewThisShared_bef153: "Erstellen Sie ein Konto, um diese freigegebene Anlage anzuzeigen",
couldNotCheckAccess_c29580: "Der Zugriff konnte nicht überprüft werden",
accessNotAvailable_7c84ab: "Zugriff nicht verfügbar",
thisShareIsntLinkedToYourAccount_305fbe: "Diese Freigabe ist noch nicht mit Ihrem Konto verknüpft oder der Eigentümer hat den Zugriff widerrufen. Wenn Sie gerade eine Einladung angenommen haben, aktualisieren Sie die Seite, um es erneut zu versuchen.",
backToAssets_caff2b: "Zurück zu den Anlagen",
refreshAccess_822875: "Zugriff aktualisieren",
thisAssetIsNotSharedWithYour_76b685: "Diese Anlage ist nicht für Ihren verknüpften Kontakt freigegeben oder die Freigabe wurde für einen anderen Kontaktdatensatz erstellt.",
shareDeclined_292608: "Freigabe abgelehnt",
youPreviouslyDeclinedAccessToThisAsset_d9ccbb: "Sie haben zuvor den Zugriff auf diese Anlage abgelehnt.",
acceptSharedAsset_79b229: "Geteilte Anlage akzeptieren",
declineSharedAsset_6908ef: "Geteilte Anlage ablehnen",
sharedBy_a5fe3b: "Geteilt von",
youaposllBeAbleToView_bc03b3: "Sie können Folgendes ansehen",
acceptToViewThisAssetWithThe_8df15c: "Nehmen Sie an, um diese Anlage mit dem oben genannten Zugriff anzusehen, oder lehnen Sie ab, um die Einladung zu entfernen.",
assetdetail_27a5fa: "asset-detail",
templateName_0a8669: "Checklistenname *",
templateNameRequired_5db301: "Checklistenname (erforderlich)",
selectOneOrMore_1489f2: "Wählen Sie eine oder mehrere aus",
updateChecklist_fce28f: "Checkliste aktualisieren",
editChecklist_8c20d6: "Checkliste bearbeiten",
inspectionObjective_6129b6: "Inspektionsziel *",
describeWhatYouWantToInspectEg_1fb338: "Beschreiben Sie, was Sie prüfen möchten (z. B. Fahrzeugprüfung vor dem Kauf, Sicherheit und mechanischer Zustand).",
egPrepurchaseVehicleCheckSafetyAndMechanical_871268: "z.B. Überprüfung des Fahrzeugs vor dem Kauf, Sicherheit und mechanischer Zustand",
inspectionObjective_ce4266: "Inspektionsziel",
categories_1c14ef: "Kategorien *",
assetOptional_95db78: "Anlage (optional)",
selectAnAsset_9dd87a: "Wählen Sie eine Anlage aus",
inspectionDepth_2b1225: "Inspektionstiefe",
targetDurationMinutesOptional_fe3727: "Zieldauer (Minuten, optional)",
targetDurationInMinutes_1897b3: "Zieldauer in Minuten",
evidenceMode_e83c42: "Nachweismodus",
optimizeForSpeed_56e47b: "Auf Geschwindigkeit optimieren",
optimizationFocusOptional_0ebfbe: "Optimierungsfokus (optional)",
failonlyEvidenceFocusKeepsEvidenceModeOn_1f0e17: "Der Nachweisfokus „Nur Fehler“ behält den Nachweismodus bei der Nur-Fehler-Erfassung bei.",
baseTemplateOptional_d80914: "Basisvorlage (optional)",
preferToBuildItYourselfCreateManually_ae612e: "Möchten Sie es lieber selbst bauen? Manuell erstellen",
draftSetup_a9804f: "Entwurfseinstellungen",
guidance_b5e0b5: "Anleitung",
useThisWorkspaceToIterateObjectiveDuration_76a28d: "Beschreiben Sie, was Sie prüfen und warum. Die KI entwirft die Checkliste; Sie prüfen und ändern sie, bevor etwas gespeichert wird.",
baseTemplate_54f2a3: "Basisvorlage",
generatingTemplateDraft_8fdb48: "Checklistenentwurf wird erstellt…",
thisMayTakeAMoment_2cd85b: "Dies kann einen Moment dauern.",
buyUsageCredits_a49d2e: "Nutzungsguthaben kaufen",
templateName_954ab9: "Checklistenname",
draftRationaleAndWarnings_0ce71c: "Begründung und Warnungen zum Entwurf",
groupsItems_9bcc66: "Gruppen und Elemente",
draftSummary_4e141c: "Entwurfszusammenfassung",
warnings_1430f9: "Warnungen",
reviewDraft_6a9bff: "Entwurf prüfen",
editThenSaveOrDiscard_f1ef70: "Bearbeiten, dann speichern oder verwerfen",
inspectionreport_04aa89: "inspection-report",
createARecurringJob_4a519d: "Wartungsplan erstellen",
newRecurringJob_dcc457: "Neuer Wartungsplan",
couldntLoadRecurringJobs_cbd362: "Wartungspläne konnten nicht geladen werden",
noRecurringJobsYet_c5a4c5: "Noch keine Wartungspläne",
openCurrentJob_cf8169: "Aktuellen Arbeitsauftrag öffnen",
end_a2bb9d: "Ende",
jobreport_c30f90: "job-report",
pleaseWaitFinalisingYourSubscription_9839a5: "Bitte warten – Ihr Abonnement wird abgeschlossen.",
openPrivacyAmpData_453313: "Datenschutz & Daten öffnen",
retryLoadingYourWorkspace_be5137: "Versuchen Sie erneut, Ihren Arbeitsbereich zu laden",
signInToViewThisQuoteRequest_317846: "Melden Sie sich an, um diese Angebotsanfrage anzuzeigen",
thisInviteWasSentToYourEmail_d77859: "Diese Einladung wurde an Ihre E-Mail-Adresse gesendet. Melden Sie sich an – oder erstellen Sie mit dieser E-Mail-Adresse ein kostenloses Konto – und die Angebotsanfrage wird automatisch geöffnet.",
retryLoadingQuoteInvitation_7c3b72: "Versuchen Sie erneut, die Angebotseinladung zu laden",
ifTheInviteWasSentToA_2463c0: "Wenn die Einladung an eine andere E-Mail-Adresse gesendet wurde, melden Sie sich mit dieser Adresse an, um sie zu öffnen.",
retryLoadingQuoteContext_2406e9: "Versuchen Sie erneut, den Angebotskontext zu laden",
loadingQuoteDetailsAndSavedDraft_3c2a11: "Angebotsdetails und gespeicherter Entwurf werden geladen",
requestDetails_bf5023: "Anfragedetails",
additionalContextFromClient_1d46de: "Zusätzlicher Kontext (vom Kunden)",
yourQuote_756213: "Ihr Angebot *",
yourQuoteRequired_afd50e: "Ihr Angebot (erforderlich)",
durationEstimateOptional_ace4e9: "Dauerschätzung (optional)",
availabilityWindowOptional_9e64b7: "Verfügbarkeitsfenster (optional)",
materialsIncluded_5ffbdc: "Materialien enthalten",
materialsDetails_72ea3e: "Materialdetails",
details_4dade5: "Details...",
warrantyOptional_010797: "Garantie (optional)",
eg12Months_0ff628: "z.B. 12 Monate",
additionalDetails_04831c: "Weitere Details...",
attachmentsOptional_106896: "Anhänge (optional)",
loadingInspection_1ad221: "Inspektion wird geladen…",
whatTheInspectionFound_b53913: "Was die Inspektion ergab",
avgCondition_6b3737: "Durchschnittlicher Zustand",
needsDecision_229276: "Entscheidung erforderlich",
inspectorNotes_2f7e20: "Notizen des Prüfers",
recommendedRepair_a70281: "Empfohlene Reparatur",
labourMaterials_08ee77: "Arbeit und Materialien",
estimatedCost_35caa4: "Geschätzte Kosten",
jobsFromThisReport_fa5fee: "Arbeitsaufträge aus diesem Bericht",
tapAJobToSeeFullDetails_fe7c8c: "Tippen Sie auf einen Arbeitsauftrag, um alle Details und den Status anzuzeigen.",
couldNotSyncReview_375861: "Prüfung konnte nicht synchronisiert werden",
inspectionreview_077ff2: "inspection-review",
acceptTeamInvitation_2f956c: "Teameinladung annehmen",
acceptInvitation_f41d2a: "Einladung annehmen",
declineTeamInvitationForNow_7ce799: "Teameinladung vorerst ablehnen",
yourTeams_d63712: " Ihre Teams",
createNewTeam_a8d9ef: "Neues Team erstellen",
addTeam_046c3a: "Team hinzufügen",
noTeam_178b88: "Kein Team",
createATeamToCollaborateInviteContractors_bf3947: "Erstellen Sie ein Team zur Zusammenarbeit, laden Sie Auftragnehmer ein und weisen Sie Arbeitsaufträge zu.",
createTeam_8d826c: "Team erstellen",
createTeam_8b8973: "Team erstellen",
giveYourTeamAName_0161ea: "Geben Sie Ihrem Team einen Namen",
teamName_9b11ed: "Teamname",
egAcmeInspections_60df82: "z.B. Acme-Inspektionen",
newTeam_7ff544: "Neues Team",
searchMembers_bdad23: "Mitglieder suchen…",
searchMembers_a1d97a: "Mitglieder suchen",
usedToMatchWorkToPeopleA_4d8242: "Wird verwendet, um Arbeit passenden Personen zuzuordnen. Ein Auftrag kann eine Fähigkeit als „Ein Muss“ kennzeichnen; wer sie nicht hat, wird dafür nicht vorgeschlagen.",
makeOwner_f99257: "Zum Inhaber machen",
resetTwofactor_4efb84: "Zwei-Faktor-Reset",
removeMember_1c31d1: "Mitglied entfernen",
closeMenu_6c9fc9: "Menü schließen",
invitations_4b0b9f: " Einladungen",
workspaceMembershipGrantsAppAccessContactRecords_e5c34b: "Workspace-Mitgliedschaft gewährt App-Zugriff. Kontaktdatensätze bleiben getrennt und können mit der Arbeit verknüpft werden, ohne Mitglied zu werden.",
inviteANewTeamMember_52559c: "Laden Sie ein neues Teammitglied ein",
invitePeople_e1eb97: "Leute einladen",
emailAddressesForInvitationsOnePerLine_5e7e7e: "E-Mail-Adressen für Einladungen, eine pro Zeile",
addOneOrMoreAddressesSeparatedBy_162bd6: "Fügen Sie eine oder mehrere Adressen hinzu, getrennt durch eine neue Zeile oder ein Komma.",
whatShouldTheyBeAbleToDo_224294: "Was sollten sie können?",
cancelInviteForm_156d89: "Einladungsformular abbrechen",
noPendingInvitations_8d0735: "Keine ausstehenden Einladungen",
showMeHowToInviteAMember_6b43bc: "Zeigen Sie mir, wie ich ein Mitglied einlade",
showMeHowToInviteSomeone_61b6a4: "Zeigen Sie mir, wie ich jemanden einlade",
teamSettings_373140: " Teameinstellungen",
workspaceDefaultsAccount_4ae7a6: "Workspace-Standardeinstellungen (Konto)",
baselineDefaultsForTheWorkspaceYouCan_f78072: "Baseline-Standardwerte für den Arbeitsbereich. Sie können diese auch unter Konto → Einstellungen festlegen, wenn Sie nicht in einem Team sind.",
workspaceCommunication_2c579b: "Kommunikation im Arbeitsbereich",
teamOverrides_4c6f5e: "Teamüberschreibungen",
overrideThisTeamOrKeepItInheriting_1d3b9a: "Überschreiben Sie dieses Team oder behalten Sie bei, dass es die Standardeinstellungen des Arbeitsbereichs erbt.",
teamCurrencyMode_f9eea7: "Team-Währungsmodus",
inheritWorkspace_879a54: "Arbeitsbereich erben",
override_842192: "Überschreibung",
teamCommunicationMode_d0ba75: "Team-Kommunikationsmodus",
effectiveDefaultsInThisContext_3905f8: "In diesem Zusammenhang wirksame Standardwerte",
onlyWorkspaceOwnersAndAdminsCanChange_325bf7: "Nur Workspace-Inhaber und Administratoren können diese Standardeinstellungen ändern.",
openWorkspaceAIAndAutomationAudit_f2fd0f: "KI- und Automatisierungsprotokoll des Arbeitsbereichs öffnen",
workspaceAIAutomationAudit_79db57: "Workspace KI- und Automatisierungsaudit",
renameTeam_bbd28e: "Team umbenennen",
leaveTeam_b445f9: "Team verlassen",
transferOwnership_a6819e: "Eigentum übertragen",
deleteTeam_a9661e: "Team löschen",
chooseAMemberToOfferOwnershipTo_ee74d9: "Wählen Sie ein Mitglied, dem Sie die Inhaberschaft anbieten. Das Mitglied muss zustimmen; danach sind Sie Admin.",
input_b568d4: "Eingabe",
plainlanguageGuideForThisTrigger_546a3a: "Leicht verständliche Anleitung für diesen Auslöser",
whatYouCanPassToAnotherSystem_3385b2: "Was Sie an ein anderes System übergeben können",
sendingDataOutTypicalWebhookStep_9fa855: "Versenden von Daten (typischer Webhook-Schritt)",
fixedPartReplaceTheExampleWebAddress_b73594: "Fester Teil – ersetzen Sie die Beispiel-Webadresse durch Ihre",
automaticPartFilledFromThisTriggerWhen_a65fba: "Automatischer Teil – wird beim Ausführen des Rezepts aus diesem Auslöser befüllt",
optionalFiltersAbove_b7c00b: "Optionale Filter (oben)",
trigger_56cc41: "trigger.",
trigger_082e86: "trigger.…",
advancedRecipeBuilder_799724: "Erweiterter Rezeptersteller",
fullTriggerConditionAndStepControlFor_c176d8: "Vollständige Steuerung von Triggern, Bedingungen und Schritten für Power-User. Bevorzugen Sie Guided für neue Automatisierungen, wenn eine Vorlage passt.",
triggerCatalog_b27d78: "Trigger-Katalog",
actionCatalog_44816c: "Aktionskatalog",
howToCreateARecipe_18bda4: "So erstellen Sie ein Rezept",
recipesConnectATriggerWhenToOne_9c1ff3: "Rezepte verbinden einen Auslöser (wann) mit einer oder mehreren Aktionen (was). In der Produktion läuft nichts, bis Sie den Entwurf aus der Liste rechts aktivieren.",
recipeWizard_6830a5: "Rezept-Assistent",
buildADraftBelowThenActivateIt_219398: "Erstellen Sie unten einen Entwurf und aktivieren Sie ihn dann aus der Rezeptliste.",
syncCompletedInspectionsToCRM_2594a7: "Synchronisieren Sie abgeschlossene Inspektionen mit CRM",
optionalInternalNote_dedb5c: "Optionale interne Notiz",
triggerType_a8b3dc: "Triggertyp",
chooseWhenThisRecipeShouldRunOptions_065235: "Wählen Sie aus, wann dieses Rezept ausgeführt werden soll. Die Optionen sind nach Themen gruppiert. Der Funktionscode unter jedem Namen ist eine optionale Referenz, wenn Sie Felder aus einem anderen System zuordnen.",
selectedTrigger_4573c4: "Ausgewählter Trigger",
intervalMinutes_617c3f: "Intervallminuten",
conditionsOptional_d2f0fb: "Bedingungen (optional)",
onlyRunWhenTheIncomingEventMatches_c87bd3: "Wird nur ausgeführt, wenn das eingehende Ereignis mit jeder von Ihnen hinzugefügten Zeile übereinstimmt. Verwenden Sie kurze Feldnamen aus Ihrem Quellsystem (z. B. status oder id im Datensatz). Lassen Sie es leer, damit es jedes Mal ausgeführt wird, wenn dieser Auslöser ausgelöst wird.",
jSONPath_a8136f: "JSON-Pfad",
dataobjectstatus_f2b5ba: "data.object.status",
value_8dce17: "Wert",
completedOrOpenpaused_f935e5: "completed oder [\"open\",\"paused\"]",
addCondition_42fe69: "Bedingung hinzufügen",
noFiltersEveryMatchingTriggerRunsThe_5cdf5e: "Keine Filter – jeder passende Trigger führt die Aktionen aus.",
actionsRunInOrder_dd55c2: "Aktionen (in der angegebenen Reihenfolge ausführen)",
pickWhatEachStepShouldDoThen_8b8ac5: "Wählen Sie aus, was jeder Schritt bewirken soll, und fügen Sie dann JSON ein oder bearbeiten Sie es. Verwenden Sie das graue Feld unter Ihrem Auslöser für kopierfertige Beispiele und benennen Sie Felder um, damit sie zu Ihrer anderen Software passen.",
actionType_fece43: "Aktionstyp",
fixedValuesJSON_3002d2: "Feste Werte (JSON)",
valuesFromTheEventJSON_11f1b5: "Werte aus dem Ereignis (JSON)",
urltriggerdatawebhookcallbackUrl_24747a: "{\"url\": \"trigger.data.webhook.callbackUrl\"}",
addAction_2824f0: "Aktion hinzufügen",
stableKeysScopesSchemasSamplesAndConnector_a9453b: "Stabile Schlüssel, Bereiche, Schemata, Beispiele und Connector-Hinweise für externe Builder.",
zapier_569964: "Zapier",
powerAutomate_81fa07: "Power Automate",
queuedSkippedSucceededAndFailedRecipeRuns_ceb06e: "In die Warteschlange gestellte, übersprungene, erfolgreiche und fehlgeschlagene Rezeptausführungen mit manueller Wiederholung.",
noRunsHaveBeenRecordedYet_cfe5db: "Es wurden noch keine Läufe aufgezeichnet.",
importAssetsOrContactsFromACSV_8bb4c4: "Importieren Sie Anlagen oder Kontakte aus einer CSV- oder Excel-Datei. Ordnen Sie Spalten zu, zeigen Sie eine Vorschau der Validierung an und erstellen Sie dann Datensätze.",
fileIntegrationHealth_2a85ee: "Zustand der Dateiintegration",
credentialsScopeRunsUnderYourSignedinWorkspace_7e301a: "Anmeldeinformationen/Umfang: Läuft unter Ihren angemeldeten Workspace-Berechtigungen; Dateiinhalte werden zugeordnet, bevor Datensätze erstellt werden.",
chooseACsvOrXlsxFileThe_d63529: "Wählen Sie eine CSV- oder XLSX-Datei. Die erste Zeile muss Spaltenüberschriften enthalten.",
chooseFileToImport_7450d5: "Wählen Sie die zu importierende Datei aus",
whatAreYouImporting_15be02: "Was importieren Sie?",
startOver_51dd91: "Beginnen Sie von vorne",
mapColumnsAndOptionalDefaults_b4665a: "Zuordnen von Spalten und optionalen Standardwerten",
flowFileObjectTypeAssetscontactsThisStep_1f9978: "Ablauf: Datei → Objekttyp (Anlagen/Kontakte) → dieser Schritt → Vorschau (Validierung) → Importieren. Wählen Sie hier aus, welche Spalte in Ihrer Tabelle jedes App-Feld speist. Wenn eine Spalte fehlt oder Zellen leer sind, legen Sie unten einen Standardwert fest – er füllt jede Zeile aus, in der dieser Wert fehlt. Mit * gekennzeichnete Felder benötigen eine Spalte oder einen Standardwert. In der Vorschau werden Probleme auf Zeilenebene angezeigt (z. B. ein für den Anlagentyp dieser Zeile ungültiger Untertyp), bevor etwas gespeichert wird.",
browseAllowedSubtypeValuesByAssetType_a490ea: "Durchsuchen Sie zulässige Untertypwerte nach Anlagentyp",
browseAllowedSubtypeValuesByAssetType_580a2c: "Zulässige Untertypwerte durchsuchen (nach Anlagentyp)",
sameFieldsAsWhenYouAddAn_66723f: "Dieselben Felder wie beim Hinzufügen einer Anlage über die Registerkarte „Anlagen“ (Schnellerstellung).",
sameToplevelFieldsAsAssetDetailsSubtype_f2742b: "Dieselben Felder der obersten Ebene wie Anlage → Details (Untertyp, Kritikalität und Tag-Listen). Der strukturierte Optionssatz JSON wird hier nicht importiert – verwenden Sie einfachen Text und zulässige Tag-Werte, die in der obigen Referenz aufgeführt sind.",
sameAsAddContactWhoThisRecord_ba62a1: "Identisch mit Kontakt hinzufügen – wen dieser Eintrag darstellt.",
whoCanSeeThisContactDefaultRoles_144799: "Wer kann diesen Kontakt sehen? Standardrollen, wenn die Datei keine hat.",
defaultIfEmpty_4d3688: "Standard, wenn leer",
optionalUseForEveryRowWhenBlank_6bd308: "Optional: Für jede Zeile verwenden, wenn leer",
oneDefaultSubtypeAppliesToEveryRow_1adca0: "Ein Standard-Subtyp gilt für jede Zeile mit einer leeren Subtyp-Zelle. Wenn Ihre Datei Anlagentypen mischt, muss dieser Wert für alle gültig sein – verwenden Sie stattdessen normalerweise eine Subtype-Spalte.",
whenAMatchingRecordAlreadyExists_2bc530: "Wenn bereits ein passender Datensatz vorhanden ist",
updateMatchingRecords_acbd0a: "Übereinstimmende Datensätze aktualisieren",
matchAssetsByExternalIDAndContacts_440e6c: "Ordnen Sie Anlagen anhand externer ID und Kontakte per E-Mail zu.",
skipMatchingRecords_c0ae31: "Überspringen Sie übereinstimmende Datensätze",
leaveExistingAssetWRXRecordsUnchanged_8f82ad: "Bestehende AssetWRX-Datensätze unverändert lassen.",
everyRowHasOneExplicitActionValidation_3af4e8: "Jede Zeile hat eine explizite Aktion. Validierungsfehler werden nicht geschrieben.",
dataToImport_06e654: "Zu importierende Daten",
valuesReadFromFileThisRowWill_bd4d2f: "Aus der Datei gelesene Werte (diese Zeile wird nicht importiert)",
noNonemptyFieldsOnThisRow_33c6ae: "Keine nicht leeren Felder in dieser Zeile.",
noMappedValuesForThisRow_b90088: "Für diese Zeile sind keine Werte zugeordnet.",
importFinished_c3e89b: "Import abgeschlossen",
created_05e8fd: "Erstellt ",
andMore_c2145e: "…und mehr",
importAnotherFile_6dc962: "Eine andere Datei importieren",
closeSubtypeReference_be22c0: "Subtyp-Referenz schließen",
subtypeValuesImport_0c957e: "Subtypwerte (Import)",
useTheCodeOrLabelInThe_0a2125: "Verwenden Sie den Code oder die Beschriftung in der Spalte „Subtyp“. Der Wert muss mit dem Anlagentyp in derselben Zeile (oder Ihrem Standardtyp) übereinstimmen.",
connected_3dfd4d: "connected.*",
connectedruleexecuted_594141: "connected.rule.executed",
temperature_7033e9: "temperature",
xApiKey_cef935: "X-Api-Key",
httpspartnerexamplecomhooksassetwrx_79a38c: "https://partner.example.com/hooks/assetwrx",
jobId_f3d2e2: "jobId",
status_48a366: "status",
title_3c6de1: "title",
tESTASSET001_6a6a4b: "TEST-ASSET-001",
opsCopilot_5a267c: "Ops-Copilot",
httpsmcpexamplecom_a938f2: "https://mcp.example.com",
httpsexamplecomwebhooksassetwrx_fc61e9: "https://example.com/webhooks/assetwrx",
retryTestConnection_c9f32a: "Testverbindung erneut versuchen",
refreshLogs_f970c3: "Protokolle aktualisieren",
credentialAndScopeClarity_6593d1: "Klarheit der Anmeldeinformationen und des Umfangs",
assistantAccessStillRequiresWorkspaceEnablementPlus_df3128: "Der Assistentenzugriff erfordert weiterhin die Aktivierung im Arbeitsbereich sowie die Freigabe pro Werkzeug/Ressource im Katalog.",
retryConnectionTest_4382ef: "Wiederholen Sie den Verbindungstest",
whatThisWizardSetsUp_ced2db: "Was dieser Assistent einrichtet",
thisExposesAssetWRXItselfAsAFirstparty_a9b397: "Dadurch wird AssetWRX selbst als Erstanbieter-MCP-Server für den aktuellen Arbeitsbereich verfügbar gemacht. Externe MCP-Clients erhalten arbeitsbereichsbezogene Lesezugriffe und Schreibwerkzeuge, die zuerst einen Vorschlag erstellen, nur über das Backend.",
assetWRXSystemConnector_bbcfee: "AssetWRX-System-Connector",
thisAssistantConnectorIsAlwaysAvailableFor_6e5481: "Dieser Assistenten-Connector ist immer für den Arbeitsbereich verfügbar, für normale Benutzer verborgen und kann nicht entfernt werden.",
whatYouGet_8ac7aa: "Was Sie bekommen",
proposalfirstWritesAuditHistoryAndPerworkspaceEnablement_4086cb: "Schreibvorgänge zuerst als Vorschlag, Prüfverlauf und Aktivierung pro Arbeitsbereich.",
readsExposedInV1_a02d0c: "In v1 verfügbare Lesezugriffe",
workspaceSummaryDashboardStatusAssetsInspectionsJobs_ac16ca: "Arbeitsbereichszusammenfassung, Dashboard-Status, Anlagen, Inspektionen, Arbeitsaufträge, Checklisten und Assistentenkontext werden dort gelesen, wo dies sicher ist.",
builtinAssistantCapabilities_e47a5d: "Integrierte Assistentenfunktionen",
writeBehaviorInV1_73d808: "Schreibverhalten in v1",
materialToolsCreateProposalsFirstNothingCommits_9951b2: "Wesentliche Werkzeuge erstellen zuerst Vorschläge. Nichts wird ausgeführt, bis ein Inhaber oder Admin hier zustimmt (sie werden benachrichtigt), es sei denn, der Inhaber lässt diese Aktion ohne Freigabe laufen; danach ruft der Client `confirm_proposed_action` auf.",
enableWorkspaceExposure_3b8aed: "Freigabe des Arbeitsbereichs aktivieren",
turnOnTheEndpointConfirmTheWorkspace_c9acbe: "Schalten Sie den Endpunkt ein, bestätigen Sie den Arbeitsbereichsstatus und legen Sie fest, wie lange Schreibvorschläge gültig bleiben, bevor sie ablaufen.",
endpoint_92ec63: "Endpunkt",
proposalTTLMinutes_b08405: "Vorschlags-TTL (Minuten)",
validRange5To1440MinutesDefault_81859c: "Gültiger Bereich: 5 bis 1440 Minuten. Standard: 30 Minuten.",
approveToolsAndResources_6e4769: "Genehmigen Sie Tools und Ressourcen",
keepOnlyTheWorkspacesafeMCPSurfaceYou_433b1d: "Behalten Sie nur die arbeitsbereichssichere MCP-Oberfläche, die externe Clients sehen sollen. Deaktivierte Zeilen werden in `tools/list` und `resources/list` ausgeblendet.",
noFirstpartyMCPToolsAreRegisteredYet_a45543: "Es sind noch keine MCP-Tools von Erstanbietern registriert.",
noFirstpartyMCPResourcesAreRegisteredYet_58e317: "Es sind noch keine MCP-Ressourcen von Erstanbietern registriert.",
serviceaccountKeysAndScopes_8f39e0: "Dienstkontoschlüssel und -bereiche",
thisWizardDoesNotMintSecretsDirectly_ba8449: "Dieser Assistent erzeugt keine Geheimschlüssel. Externe MCP-Clients müssen vorhandene API-Schlüssel von Workspace-Dienstkonten verwenden, die unter API-Schlüssel & Zugriff erstellt wurden.",
requiredScopeModel_206642: "Erforderliches Berechtigungsmodell",
readsRequireMcpreadPlusTheRelevantDomain_efecc5: "Lesevorgänge erfordern „mcp:read“ plus den relevanten Domänen-Lesebereich wie „assets:read“.",
writeProposalsRequireMcpinvokePlusTheRelevant_bde894: "Schreibvorschläge erfordern `mcp:invoke` plus den entsprechenden Schreibbereich, z. B. `jobs:write`.",
proposalConfirmationAndCancellationStayBoundTo_b8a213: "Bestätigung und Abbruch von Vorschlägen bleiben an denselben Arbeitsbereich und den anfragenden Schlüssel gebunden.",
clientSetupExample_dde719: "Client-Setup-Beispiel",
safetyDefaults_f1e85c: "Sicherheitsvorgaben",
neverHandOutUnlessTheClientIs_26c700: "Geben Sie niemals „*“ aus, es sei denn, der Client ist vollständig vertrauenswürdig. Bevorzugen Sie zunächst schreibgeschützte Schlüssel und dann separate vorschlagsfähige Schlüssel für kontrollierte Automatisierungen.",
reviewProposalsAndAuditHistory_945ebe: "Vorschläge und Prüfverlauf ansehen",
useThisStepToConfirmExternalClients_209a95: "Prüfen Sie in diesem Schritt, dass externe Clients nur die vorgesehenen Ressourcen lesen und wesentliche Aktionen weiterhin zuerst als Vorschlag laufen und nachvollziehbar bleiben.",
proposalHistory_0f9af9: "Vorschlagsverlauf",
noFirstpartyMCPProposalsYet_62c81f: "Noch keine MCP-Vorschläge von Erstanbietern.",
mcpProposalApprove: "Freigeben",
mcpProposalDecline: "Ablehnen",
mcpProposalDecideFailed: "Die Entscheidung konnte nicht gespeichert werden",
mcpAwaitingApprovalTitle: "Wartet auf Ihre Freigabe ({{count}})",
mcpAwaitingApprovalHint: "Ein KI-Assistent möchte diese Änderungen vornehmen. Nichts passiert, bevor Sie zustimmen; abgelehnte oder abgelaufene Anfragen werden nie ausgeführt.",
mcpApproveAll: "Alle freigeben ({{count}})",
mcpDeclineAll: "Alle ablehnen ({{count}})",
mcpApproveAllConfirmTitle_one: "{{count}} Anfrage freigeben?",
mcpApproveAllConfirmTitle_other: "{{count}} Anfragen freigeben?",
mcpApproveAllConfirmBody: "Jede hier wartende Anfrage „{{action}}“ wird freigegeben, und die KI kann sie dann ausführen.",
mcpDeclineAllConfirmTitle_one: "{{count}} Anfrage ablehnen?",
mcpDeclineAllConfirmTitle_other: "{{count}} Anfragen ablehnen?",
mcpDeclineAllConfirmBody: "Keine der hier wartenden Anfragen „{{action}}“ wird ausgeführt.",
mcpShowAll: "Alle {{count}} anzeigen",
mcpShowFewer: "Weniger anzeigen",
mcpApprovalRequired: "Freigabe erforderlich",
mcpApprovalNotRequired: "Läuft ohne Freigabe",
mcpWaiveApprovalTitle: "„{{name}}“ ohne Freigabe ausführen lassen?",
mcpWaiveApprovalBody: "Ein KI-Assistent kann diese Änderung dann ohne Freigabe durch Inhaber oder Admin vornehmen. Sie können die Freigabe jederzeit wieder einschalten.",
mcpWaiveApprovalConfirm: "Ohne Freigabe ausführen",
mcpApprovalUpdateFailed: "Die Freigabe für diese Aktion konnte nicht geändert werden.",
invocationAudit_06c951: "Aufrufprüfung",
noFirstpartyMCPInvocationHistoryYet_352e60: "Noch kein MCP-Aufrufverlauf für Erstanbieter.",
assetWRXMCPExposure_b699b4: "AssetWRX-MCP-Freigabe",
exposeThisWorkspaceAsAFirstpartyMCP_7fae12: "Stellen Sie diesen Arbeitsbereich als Erstanbieter-MCP-Server mit arbeitsbereichsbezogenen Lesevorgängen, Vorschlags-zuerst-Schreibvorgängen und Prüfverlauf bereit.",
firstpartySetup_16908a: "Erstanbieter-Setup",
loadingAssetWRXMCPExposure_4cc589: "AssetWRX-MCP-Freigabe wird geladen...",
loadingAssetWRXMCPExposure_ec357e: "AssetWRX-MCP-Freigabe wird geladen…",
workspaceControls_3cfefd: "Arbeitsbereich-Steuerelemente",
useServiceaccountKeysWithMcpreadForResources_d8fd58: "Verwenden Sie Dienstkontoschlüssel mit „mcp:read“ für Ressourcen und „mcp:invoke“ sowie Domänenschreibbereichen für vorschlagsfähige Tools.",
exposedTools_50a475: "Freigegebene Werkzeuge",
materialActionsStayProposalfirstEvenWhenEnabled_40b9b8: "Wesentliche Aktionen laufen weiterhin zuerst als Vorschlag, auch wenn sie hier aktiviert sind.",
exposedResources_420463: "Offengelegte Ressourcen",
resourceTemplatesStayWorkspacescopedAndAreFiltered_664498: "Ressourcenvorlagen bleiben arbeitsbereichsbezogen und werden nach Dienstkontobereichen gefiltert.",
hideMoreActions_dd5915: "Weitere Aktionen ausblenden",
hideActions_affb29: "Aktionen ausblenden",
showMoreActions_2ff0fa: "Weitere Aktionen anzeigen",
searching_ba2b5a: "Suche...",
aICanDraftThisRepairJob_247024: "KI kann diesen Reparaturauftrag entwerfen",
why_d77989: "Warum?",
autoprepFollowupJobsAndScheduleTighteningSuggested_8be7b7: "Automatische Vorbereitung, Folgearbeitsaufträge und Terminverkürzung empfohlen",
reviewAutomations_a7cc10: "Überprüfen Sie Automatisierungen",
workingOnThisText_24726e: "Ich arbeite an diesem Text...",
acceptIndividuallyOrInBulkEachWrites_bf195f: "Einzeln oder alle auf einmal übernehmen – jeweils wird der Entwurf in den passenden Punkt unten geschrieben.",
scheduledDate_b41cf0: "Geplantes Datum",
selectADate_642b09: "Wählen Sie ein Datum aus",
chooseAssignee_3f1566: "Wählen Sie den Beauftragten",
searchRequests_f13d82: "Anfragen durchsuchen",
noRequestsMatchYourSearch_a6c94d: "Keine Anfragen entsprechen Ihrer Suche.",
reportResponsePending_44c9b7: "Antwort auf Bericht steht aus",
completionReviewPending_b4145c: "Abschlussprüfung steht noch aus",
confirmDate_14424a: "Datum bestätigen",
confirmTheScheduledDate_b2fc2c: "Bestätigen Sie das geplante Datum",
requestADifferentTime_0d7d3e: "Fordern Sie eine andere Zeit an",
cancelRequest_84837a: "Anfrage abbrechen",
cancelThisRequest_f56a63: "Diese Anfrage abbrechen",
preferredDate_921625: "Gewünschtes Datum",
sendTheRescheduleRequest_b5dc9f: "Senden Sie die Umplanungsanfrage",
cancelTheRescheduleRequest_9fb111: "Stornieren Sie die Neuplanungsanforderung",
chooseNextAction_94f5b9: "Wählen Sie die nächste Aktion",
chooseAWorkPathTheRequestDetails_804dd3: "Wählen Sie einen Arbeitspfad. Die Anfragedetails bleiben zur Bestätigung, Zuweisung und zum Zeitpunkt vorausgefüllt.",
recommended_9ef937: "Empfohlen",
createWorkFromRequest_47ff21: "Arbeit aus Anfrage erstellen",
confirmOwnerDueDatePriorityAndInstructions_8bc8fe: "Bestätigen Sie zuständige Person, Fälligkeitsdatum, Priorität und Anweisungen, bevor Sie den Arbeitsauftrag erstellen",
inspectRequest_5569d2: "Inspektion zur Anfrage",
chooseStartNowAssignOrScheduleAfter_c334b8: "Wählen Sie „Jetzt starten“, „Zuweisen“ oder „Planen“, nachdem Sie Checkliste und Umfang bestätigt haben",
whoApprovesWorkOnThisAsset_2e42d2: "Wer genehmigt die Arbeit an dieser Anlage?",
inspectionConditionTrend_179a6f: "Inspektionszustandstrend",
searchNameCompanyRole_baab25: "Name, Firma oder Rolle suchen",
tryClearingTheSearchOrFilters_0818c7: "Versuchen Sie, die Suche oder die Filter zu löschen.",
roleCompany_feef85: "Rolle · Unternehmen",
changeAccess_fec7d5: "Zugriff ändern",
overdueWorkDocumentRiskAndOpenInspection_66d5d1: "Überfällige Arbeiten, Dokumentenrisiko und offener Inspektionsstatus.",
noUrgentItemsRightNow_d3111a: "Im Moment keine dringenden Punkte.",
responsibleTeam_fd5898: "Verantwortliches Team",
approvesWork_3d9f4c: "Genehmigt Arbeit",
signsOffInspectionsAndJobCompletionsAnd_35b573: "Nimmt Inspektionen und Auftragsabschlüsse ab und prüft Dokumente.",
draftInProgress_82d43c: "Entwurf und in Bearbeitung",
healthComplianceAndRiskAreScoredFrom_3c3736: "Gesundheit, Konformität und Risiko werden anhand der gesamten Aufzeichnung bewertet und dem Eigentümer und Team der Anlage angezeigt.",
noDocumentsMatchTheCurrentFilters_193238: "Keine Dokumente entsprechen den aktuellen Filtern.",
noDocumentDatesThisMonth_01f2cb: "Keine Dokumentdaten für diesen Monat.",
noDocumentsOnThisDay_ed643f: "Keine Dokumente an diesem Tag.",
plannedRunsWorkInFlightAndCompleted_12c7f2: "Geplante Durchläufe, laufende Arbeiten und abgeschlossene Berichte für diese Anlage.",
startAnInspectionToEstablishConditionAnd_5e3ce5: "Starten Sie eine Inspektion, um den Zustand und nötige Folgearbeiten festzustellen.",
completedCancelledInspections_118586: "Abgeschlossene und abgebrochene Inspektionen",
scheduledActiveAndClosedWorkTiedTo_bdec69: "Geplante, aktive und geschlossene Arbeiten, die mit dieser Anlage verknüpft sind.",
noJobsForThisAsset_778118: "Keine Arbeitsaufträge für diese Anlage",
createFollowupWorkForThisAssetWhen_346e1d: "Erstellen Sie Folgearbeiten für diese Anlage, wenn eine Aktion erforderlich ist.",
completedCancelledJobs_9dae91: "Abgeschlossene und stornierte Arbeitsaufträge",
searchKnowledge_42cfc4: "Wissen suchen",
addToKnowledge_52f38f: "Zum Wissen hinzufügen",
publicIntake_b9f61c: "Öffentliche Meldungen",
turnThisOnToGetAQR_7dd031: "Aktivieren Sie diese Option, um einen QR-Code und einen Link zu erhalten, mit denen jeder ein Problem mit dieser Anlage melden kann – kein Konto oder Anmeldung erforderlich.",
publicIntakeQRCode_71844b: "QR-Code für öffentliche Meldungen",
howItWorks_1dd6a1: "Wie es funktioniert",
"1PrintOrDisplayThisQRCode_b4b58b": "1. Drucken Sie diesen QR-Code aus oder zeigen Sie ihn auf oder in der Nähe der Anlage an.",
"2AnyoneScansItWithTheirPhone_399e27": "2. Jeder scannt ihn mit der Handykamera – ohne App oder Anmeldung.",
"3TheyDescribeTheIssueAndIt_0cf748": "3. Sie beschreiben das Problem und es landet in Ihren Anfragen.",
printThisQRCode_355b08: "Drucken Sie diesen QR-Code",
printQR_3d3e5d: "QR drucken",
copyIntakeLink_d55587: "Meldelink kopieren",
printOrShareTHISCodeItsThe_081cb8: "Drucken oder teilen Sie DIESEN Code – er ist der einzige, der ohne Konto funktioniert. Das eigene QR-Etikett der Anlage öffnet die Anlage für angemeldete Teammitglieder und fordert Außenstehende zur Anmeldung auf.",
publicIntakeIsOnButThisApp_37c7e6: "Öffentliche Meldungen sind aktiviert, aber dieser App-Build hat keine öffentliche Webadresse, auf die der QR-Code verweisen könnte, daher gibt es noch keinen Link zum Teilen. Sie wird beim Build festgelegt (EXPO_PUBLIC_WEB_APP_URL) – bitten Sie die Person, die diesen Build erstellt hat, sie zu konfigurieren. Die Web-App ist davon nicht betroffen.",
closePublicIntake_83ee14: "Öffentliche Meldungen schließen",
clearFilter_b667d6: "Filter zurücksetzen",
retire_c9714c: "Ausmustern",
cancelRetiring_021841: "Ausmustern abbrechen",
thisAssetIsStillInServiceTake_6d33c8: "Diese Anlage ist noch in Betrieb. Nehmen Sie sie zuerst außer Betrieb und mustern Sie sie dann aus.",
decommissionThisAssetFirst_3dba4e: "Diese Anlage zuerst außer Betrieb nehmen",
decommissionFirst_449932: "Zuerst Stilllegung",
whyIsItBeingRetired_424b30: "Warum wird sie ausgemustert?",
anythingTheRecordShouldSayEgReplaced_39f4f8: "Alles, was in der Aufzeichnung stehen soll – z. B. ersetzt durch Einheit B-12.",
retirementNote_69e12e: "Notiz zur Ausmusterung",
disposalOptional_664c05: "Entsorgung (optional)",
recipientBuyerScrapYardLessor_bc1312: "Empfänger – Käufer, Schrottplatz, Vermieter",
disposalRecipient_0bcdb7: "Entsorgungsempfänger",
disposalValue_7e69e8: "Entsorgungswert",
whatHappens_d208fd: "Was passiert",
retireThisAsset_843886: "Diese Anlage ausmustern",
editSharedAccess_874a55: "Gemeinsamen Zugriff bearbeiten",
canRequestWorkLetsThemSubmitInspection_66303c: "„Kann Arbeit anfordern“ ermöglicht es ihnen, Inspektions- oder Arbeitsauftragsanfragen einzureichen; „Darf anzeigen“ ist schreibgeschützt. Beide können Arbeitsaufträge und Inspektionen einsehen.",
documentsArePrivateByDefaultTurnThis_f79dc7: "Dokumente sind standardmäßig privat. Aktivieren Sie diese Option, damit sie die Dateien der Anlage herunterladen können.",
canDownloadDocuments_d483c0: "Kann Dokumente herunterladen",
thisContactIsNotLinkedToAn_cfbe9b: "Dieser Kontakt ist noch keinem App-Benutzer zugeordnet. Speichern gibt die Anlage frei, der Kontakt muss jedoch eine Kontakteinladung annehmen, bevor sie in der App angezeigt werden kann.",
relationshipToThisAsset_cc572f: "Beziehung zu dieser Anlage",
moreRelationships_1c2d3e: "Weitere Beziehungen",
howThisContactIsLinkedOnThe_b75d5d: "Wie dieser Kontakt mit dem Anlagendatensatz (Organisation/Mandant) verknüpft ist. Wählen Sie eine oder mehrere Beziehungen aus.",
whatThisContactCanDoInThe_1f7b90: "Was dieser Kontakt im freigegebenen Anlagenarbeitsbereich tun kann. „Kann Arbeit anfordern“ ermöglicht es ihnen, Inspektions- oder Arbeitsauftragsanfragen einzureichen; „Darf anzeigen“ ist schreibgeschützt. Beide können Arbeitsaufträge und Inspektionen einsehen.",
saveShare_bcf6ed: "Freigabe speichern",
qR_45e7a1: "QR",
scanOrPrintLabelsForThisAsset_c3fdde: "Etiketten für diese Anlage scannen oder drucken.",
print_5b221e: "Drucken",
qRCodeWillBeGeneratedWhenAsset_31ea4e: "QR wird generiert, wenn die Anlage gespeichert wird",
assetIntelligence_d0cf4b: "Anlagenintelligenz",
conditionNotRatedYet: "Zustand noch nicht bewertet · Inspektion nötig",
why_21e2ca: "Warum",
keepTheCurrentSchedule_ade385: "Behalten Sie den aktuellen Zeitplan bei",
keepCurrentSchedule_24ceb0: "Aktuellen Zeitplan beibehalten",
operationalReadiness_f83f30: "Betriebsbereitschaft",
noReadinessChecksCurrentlyNeedAttention_8a0ffe: "Derzeit erfordert keine Bereitschaftsprüfung Aufmerksamkeit",
foundations_2efa1e: "Grundlagen",
topCommandsForThisAsset_43db45: "Top-Befehle für diese Anlage",
seeAll_9ff264: "Alle anzeigen →",
noCompletedOrApprovedInspectionCyclesAre_58ad5b: "Es werden keine abgeschlossenen oder genehmigten Inspektionszyklen aufgezeichnet.",
noLinkedAssetsYet_f0421d: "Noch keine verknüpften Anlagen.",
viewRelationships_855c37: "Beziehungen anzeigen →",
noOpenJobsOrInprogressInspectionsAre_c07385: "Es werden keine offenen Arbeitsaufträge oder laufenden Inspektionen erfasst.",
sharedContactsAndQRScannersReportIssues_ece9d2: "Freigegebene Kontakte und QR-Scanner melden Probleme direkt in Ihre Arbeitswarteschlange.",
addArticle_2f4275: "Artikel hinzufügen",
shareLibrary_4057e3: "Bibliothek teilen",
signInToSeeThisKnowledge_4eaa03: "Melden Sie sich an, um dieses Wissen anzuzeigen",
yourSessionHasExpiredSoTheseArticles_f87fa2: "Ihre Sitzung ist abgelaufen, daher können diese Artikel nicht geladen werden. Melden Sie sich erneut an, um fortzufahren.",
couldnrsquotLoadKnowledge_da1c79: "Das Wissen konnte nicht geladen werden",
tryLoadingKnowledgeAgain_1b6aa1: "Versuchen Sie erneut, Wissen zu laden",
refineArticles_d1b417: "Artikel filtern",
kind_e00ac2: "Art",
egElectrical_0b7339: "z.B. elektrisch",
egBoilerAnnual_18e665: "z.B. Kessel, jährlich",
pinnedOnly_bd8de5: "Nur angepinnt",
egBoilerResetProcedure_91545f: "z.B. Verfahren zum Zurücksetzen des Kessels",
uRL_0e2d9b: "URL",
https_1a6627: "https://…",
content_4f9be0: "Inhalt",
writeStepsAnswerOrNotes_974f8b: "Schritte, Antworten oder Notizen schreiben ...",
chooseFile_3fd558: "Datei auswählen…",
setTitlecategoryAboveBeforeUploadingOptional_cea97d: "Legen Sie vor dem Hochladen oben den Titel/die Kategorie fest (optional).",
shortSummaryOrContext_239731: "Kurze Zusammenfassung oder Kontext",
pinned_f93121: "Angepinnt",
shareKnowledge_a28e38: "Wissen teilen",
shareWith_134bfa: "Teilen mit",
chooseContactToShareWith_f8c887: "Wählen Sie den Kontakt aus, mit dem Sie teilen möchten",
noEmailOnContact_2730d7: "Keine E-Mail bei Kontakt",
chooseContact_4a3f8f: "Kontakt auswählen…",
createLinkCopy_460e24: "Link erstellen und kopieren",
activeShares_8d41b3: "Aktive Freigaben",
revokeShare_1d9e95: "Freigabe widerrufen",
addAtLeastTwoAssetsInThis_92640d: "Fügen Sie in diesem Bereich mindestens zwei Anlagen hinzu, um Verknüpfungen zwischen ihnen zu erstellen.",
startInWork_47c346: "In „Arbeit“ starten",
propertyCategory_dfd0bc: "Immobilienkategorie",
propertySubtype_7092d7: "Immobilien-Untertyp",
vehicleClass_1807bf: "Fahrzeugklasse",
equipmentClass_f1c8f7: "Geräteklasse",
domain_9b1091: "Domäne",
furnished_8ab38e: "Möbliert",
operatingContext_c28bb5: "Betriebskontext",
usageType_0193f0: "Verwendungstyp",
mounting_26ae06: "Montage",
safetyClass_c2825e: "Sicherheitsklasse",
environment_d443a1: "Umgebung",
riskTags_391936: "Risiko-Tags",
otherAssetCategory_c3e627: "Kategorie „Sonstige Anlagen“.",
propertySystems_2983a3: "Immobiliensysteme",
conditionFlags_0fd793: "Zustandsmerkmale",
transmission_ace17e: "Getriebe",
lastServiceDate_6a44ff: "Letzter Servicetermin",
roadworthinessExpiry_a32510: "Ablauf der Verkehrssicherheit",
insuranceExpiry_5788c0: "Ablauf der Versicherung",
capacityUnit_f595ba: "Kapazitätseinheit",
useStructuredOptionSetsSoTemplateRecommendation_a4913e: "Verwenden Sie strukturierte Optionssätze, damit die Checklistenempfehlung und -generierung sauber bleibt.",
addOneOrMoreRelationshipsNowOr_bdce2c: "Fügen Sie jetzt eine oder mehrere Beziehungen hinzu oder lassen Sie das Feld leer, um diese Anlage eigenständig zu halten.",
noDraftRelationshipsAddedYet_0698d2: "Es wurden noch keine Beziehungsentwürfe hinzugefügt.",
chooseTheRelatedAsset_35789f: "Wählen Sie die zugehörige Anlage aus",
fromThisAsset_48c52c: "Von dieser Anlage",
toThisAsset_f70126: "Zu dieser Anlage",
relationshipCriticality_1a33c6: "Beziehungskritikalität",
riskPropagationMode_720d7e: "Risikoausbreitungsmodus",
propagationMode_fa66d1: "Ausbreitungsmodus",
noAssetsToVisualizeYet_c42bdd: "Noch keine Anlagen zum Visualisieren.",
links_014bcd: "Verknüpfungen",
display_574ff9: "Anzeige",
viewAffectedWork_acb250: "Betroffene Arbeiten anzeigen →",
relationshipTypes_558b4b: "Beziehungstypen",
clickToEditOrRemove_8526e9: "Klicken Sie zum Bearbeiten oder Entfernen",
understandingRisk_2e43d7: "Risiken verstehen",
whatRaisesOrLowersLikelihood_622b19: "Was die Wahrscheinlichkeit erhöht oder verringert",
whatRaisesOrLowersImpact_767cc7: "Was die Wirkung erhöht oder verringert",
noRelationshipbasedAdjustmentsToShow_47ffe9: "Keine beziehungsbasierten Anpassungen zum Anzeigen.",
likelihoodMixScoreWeightContribution_2582ca: "Wahrscheinlichkeitsmix (Score × Gewicht = Beitrag)",
impactMix_ec0686: "Auswirkungsmix",
rawWeightedValues_f4522d: "Rohgewichtete Werte",
assetRisk_54b50c: "Anlagenrisiko",
"55Matrix_f6b01d": "5×5-Matrix",
topDrivers_f8f235: "Top-Treiber",
whyThisRiskScore_6c74da: "Warum dieser Risikowert?",
mo_e9e0ce: "/Mo",
aW_073d87: "AW",
suggestedNextStep_4a96db: "Vorgeschlagener nächster Schritt: ",
complianceAndAudit_d16087: "Konformität und Audit",
moreInBreakdown_3e1121: "+ mehr in der Aufschlüsselung",
opensMapsWithDirectionsFromYourLocation_44a789: "Öffnet Karten mit Wegbeschreibungen von Ihrem Standort aus",
closeDocument_7866c7: "Dokument schließen",
openingFile_c515cb: "Datei wird geöffnet",
notDisplayingOpenItInYourBrowser_a5761f: "Wird nicht angezeigt? Öffnen Sie es in Ihrem Browser.",
openInBrowser_052269: "Im Browser öffnen",
noInappPreview_37df05: "Keine In-App-Vorschau",
previewUnavailable_36d31d: "Vorschau nicht verfügbar",
thisDocumentCouldNotBeDisplayedHere_e78b36: "Dieses Dokument konnte hier nicht angezeigt werden. Verwenden Sie unten „Im Browser öffnen“, um es zu lesen.",
theDocumentRendererIsUnavailableInThis_3dc0a5: "Der Dokumentrenderer ist in diesem Build nicht verfügbar. Verwenden Sie unten „Im Browser öffnen“.",
loadingDocument_77cac7: "Dokument wird geladen",
couldNotReadThisFile_fce43e: "Diese Datei konnte nicht gelesen werden",
theFileCouldNotBeDownloadedUse_fd63bb: "Die Datei konnte nicht heruntergeladen werden. Verwenden Sie unten „Im Browser öffnen“ oder versuchen Sie es erneut, wenn Sie eine stabile Verbindung haben.",
loadingVideo_c18920: "Video wird geladen",
workArrivesFromTheFieldAQR_d69f49: "Arbeit kommt aus dem Außendienst, über einen QR-Scan oder von einer anfragenden Person – und läuft dann bis zur Prüfung durch.",
howAssetWRXWorks_a6652b: "So funktioniert AssetWRX",
theEverydayLoopEndToEndTap_f41cec: "Der tägliche Ablauf von Anfang bis Ende. Tippen Sie auf eine Stufe, um dort einzusteigen.",
howToGetTheMostOutOf_6ecde4: "So holen Sie das Beste aus AssetWRX heraus – nach Aufgabe, mit interaktiven Anleitungen.",
loadingInspectionDetails_07441a: "Inspektionsdetails werden geladen...",
weCouldntLoadThisInspection_0d9c6e: "Wir konnten diese Inspektion nicht laden",
loadingChecklist_6d4b18: "Checkliste wird geladen…",
inspectionDetails_f70991: "Inspektionsdetails",
thisInspectionWasCreatedFromARequest_62e54f: "Diese Inspektion wurde aus einer Anfrage erstellt und bleibt mit der Zeitachse der Anfrage verknüpft.",
openSourceRequest_847fb2: "Ursprüngliche Anfrage öffnen",
clearSkip_6abff6: "Überspringen löschen",
clearsSkipSoYouCanAnswerThis_fdd91c: "Löscht das Überspringen, damit Sie diesen Punkt beantworten können.",
useYesNoPassFailStarsOrSkipBelow_c5d2c7: "Verwenden Sie „Ja/Nein“, „Bestanden/Nicht bestanden“, „Sterne“ oder „Überspringen“ unter dem Titel, um zu antworten.",
unskipItem_a158ab: "Überspringen aufheben",
unskip_cde472: "Überspringen aufheben",
skipItem_cb392b: "Element überspringen",
opensAShortFormYouCanSkip_8bc9f3: "Öffnet ein Kurzformular. Sie können mit oder ohne Notiz überspringen.",
notConfirmed_b9e09a: "Nicht bestätigt",
evidenceRecommendedAddAPhotoOfThe_f5d5bd: "Nachweise empfohlen – fügen Sie ein Foto des Problems hinzu.",
noVideosRecorded_803350: "Keine Videos aufgezeichnet",
upTo3Photos1VideoMax_382f91: "Bis zu 3 Fotos · 1 Video, max. 20 Sekunden",
inspectionAttachments_4eccaa: "Anhänge der Inspektion",
skipTheCurrentGroupOfItemsBecause_22712a: "Überspringen Sie die aktuelle Gruppe von Elementen, da keine davon zutrifft",
skipThisGroup_348a6d: "Diese Gruppe überspringen",
keyboardShortcuts_266695: "Tastaturkürzel",
closeKeyboardShortcuts_b87b09: "Tastaturkürzel schließen",
requestConversation_7db6bd: "Unterhaltung zur Anfrage",
retryExport_f58f53: "Export erneut versuchen",
completedTheWork_099993: "Die Arbeit wurde abgeschlossen",
notSharedYetUseShareAboveTo_81bebb: "Noch nicht geteilt – verwenden Sie „Teilen“ oben, um diesen Bericht an einen Kontakt zu senden.",
couldNotGenerateReport_fb1286: "Bericht konnte nicht erstellt werden",
showAllDetails_c5a7a8: "Alle Details anzeigen",
neededBeforeCompletion_304a39: "Wird vor der Fertigstellung benötigt",
completionProgress_e2e2b3: "Fertigstellungsfortschritt",
latestUpdate_749cd8: "Neuestes Update",
noUpdatesYet_24f53d: "Noch keine Updates.",
beforeYouSubmit_ede7c3: "Bevor Sie absenden:",
invoiceExtraction_b8d23c: "Rechnungsextraktion",
reviewExtractedItems_9649fe: "Überprüfen Sie extrahierte Elemente",
noLineItemsDetectedTryAClearer_7ebd61: "Keine Positionen erkannt. Versuchen Sie es mit einem klareren Foto oder fügen Sie Positionen manuell hinzu.",
removeLineItem_68fb55: "Position entfernen",
useCalculated_7192f0: "Berechneten Wert verwenden",
leaveBlankToRecordAs0Enter_74cafa: "Lassen Sie das Feld leer, um es als 0 aufzuzeichnen. Geben Sie den vollständigen Betrag für diesen Arbeitsauftrag ein.",
addLineItem_2932d8: "Position hinzufügen",
invoiceOrReceipt_bcd947: "Rechnung oder Quittung",
attached_8e632c: "Angehängt",
pDFImageOrWordDocument_812ab0: "PDF, Bild oder Word-Dokument.",
whyThisJobWasSuggested_e32a41: "Warum dieser Arbeitsauftrag vorgeschlagen wurde",
what3words_881ff5: "what3words",
filledcountsoap_1a66d3: "///filled.count.soap",
nothingToChooseFromYet_978c4e: "Noch keine Auswahl.",
reportNotAvailable_c048c4: "Bericht nicht verfügbar",
thisLinkMayBeInvalidOrThe_0e72cd: "Dieser Link ist möglicherweise ungültig oder der Bericht wird nicht mehr geteilt.",
itemsChecked_34daa1: "Geprüfte Punkte",
needAttention_46d04d: "Brauchen Aufmerksamkeit",
seeTheFullReport_d02b8d: "Sehen Sie sich den vollständigen Bericht an",
signInToRequestAccess_2e7a0e: "Melden Sie sich an, um Zugriff anzufordern",
requestSentTheTeamManagingThisAsset_56c7e0: "Anfrage gesendet. Das Team, das diese Anlage verwaltet, wird es prüfen. Sie werden benachrichtigt, wenn es antwortet.",
theTeamManagingThisAssetDeclinedThis_072c77: "Das Team, das diese Anlage verwaltet, hat diese Anfrage abgelehnt. Kontaktieren Sie sie direkt, wenn Sie der Meinung sind, dass Sie Zugriff haben sollten.",
yourRelationshipToThisAsset_088c6c: "Ihre Beziehung zu dieser Anlage",
selectARole_de9e0a: "Wählen Sie eine Rolle aus",
anythingToAddOptional_d0e207: "Gibt es noch etwas hinzuzufügen? (optional)",
egImTheTenantAtThisProperty_900046: "z.B. Ich bin der Mieter dieser Immobilie",
staySignedIn_e5f5f7: "Angemeldet bleiben",
signatureCanvas_b150c4: "Unterschriftenfeld",
opensTheTimeSelector_03fd5a: "Öffnet die Zeitauswahl",
rowDensity_0a44a7: "Reihendichte",
pullingTheLatestActivityForThisRequest_3eb3bd: "Ruft die neueste Aktivität für diese Anfrage ab.",
selectARequest_e23d7c: "Wählen Sie eine Anfrage aus",
chooseARequestToSeeItsDetail_17587d: "Wählen Sie eine Anfrage aus, um deren Details und Aktivität anzuzeigen.",
caseTimeline_ea3757: "Verlauf der Anfrage",
addACheck_a948e9: "Eine Prüfung hinzufügen",
cancelAddingACheck_a8ca4e: "Hinzufügen einer Prüfung abbrechen",
searchChecklists_bf435d: "Checklisten suchen…",
buildANewChecklistToUseAs_eeb155: "Erstellen Sie eine neue Checkliste zur Verwendung als Kontrolle",
buildANewChecklist_4597c6: "Erstellen Sie eine neue Checkliste",
requireThisCheckBeforeTheJobCan_75004c: "Diese Prüfung ist erforderlich, bevor der Arbeitsauftrag abgeschlossen werden kann",
requiredToCompleteTheJob_93fe15: "Erforderlich, um den Arbeitsauftrag abzuschließen",
offByDefaultARequiredCheckBlocks_83f24c: "Standardmäßig deaktiviert. Eine erforderliche Prüfung blockiert den Abschluss, bis sie abgeschlossen ist.",
sendACalendarInviteToSomeoneAt_1ef692: "Senden Sie eine Kalendereinladung an jemanden in der Anlage",
optionalTheyllGetAnEmailCalendarInvite_f3c0fa: "Optional – sie erhalten für dieses Zeitfenster eine E-Mail-Kalendereinladung (.ics).",
inviteToCalendar_f4347a: "Zum Kalender einladen",
thisCheckHasNoSteps_3d81af: "Diese Prüfung hat keine Schritte",
checkChangedTitle: "Jemand anderes hat diese Prüfung aktualisiert",
checkChangedBody: "Seine Antworten werden jetzt angezeigt. Antworten Sie erneut, wo nötig.",
theTemplateItCameFromIsEmpty_dee3b8: "Die Checkliste, aus der es stammt, ist leer. Bearbeiten Sie die Checkliste, um Schritte hinzuzufügen, und hängen Sie sie dann erneut an.",
savedOnThisDeviceWillSyncWhen_3db4e0: "Auf diesem Gerät gespeichert – wird synchronisiert, wenn Sie wieder online sind",
prepareWork_8aa4da: "Bereiten Sie die Arbeit vor",
loadingWorkContext_c860da: "Arbeitskontext wird geladen",
reopenCase_a32ef8: "Anfrage wieder öffnen",
reopen_61e05d: "Wieder öffnen",
conversation_2a20c7: "Gespräch",
writeAReply_dd081e: "Antwort schreiben…",
escalated_aff666: "Eskaliert",
closeWithoutAResponse_3bf706: "Schließen ohne Antwort",
closeWithoutResponse_6c6096: "Schließen ohne Antwort",
automateThisChase_49d451: "Diese Nachfass-Erinnerung automatisieren",
couldntLoadYourTemplates_b41115: "Ihre Checklisten konnten nicht geladen werden",
upcomingVisits_ecb005: "Bevorstehende Besuche",
theTeamHasPlannedWorkHereAnd_78e2ed: "Das Team hat hier Arbeiten geplant und Sie gebeten, zu bestätigen, dass jemand dort sein kann.",
whoWillLetUsIn_66de4a: "Wer lässt uns rein?",
noOneNeeded_4ab28b: "Niemand erforderlich",
theyaposllBeAskedToConfirmTheVisit_d8cb82: "Sie werden gebeten, die Besuchszeit zu bestätigen oder eine andere vorzuschlagen.",
sort_8b335a: "Sortieren:",
egReplaceWornBelt_49815f: "z.B. Ersetzen Sie den verschlissenen Riemen",
tryLoadingChecklistsAgain_bd84f3: "Versuchen Sie erneut, Checklisten zu laden",
noChecklistMatchesThisAssetTypeYet_d47d21: "Für diesen Anlagentyp gibt es noch keine Checkliste.",
createAChecklist_02f012: "Erstellen Sie eine Checkliste",
createANewChecklistTemplate_ec189b: "Erstellen Sie eine neue Checkliste",
newChecklist_d80825: "Neue Checkliste",
when_b2028c: "Wann?",
chooseWhenThisWorkShouldHappen_78b867: "Wählen Sie, wann diese Arbeit ausgeführt werden soll",
later_56e2f5: "Später",
howLongWillItTake_5c9649: "Wie lange wird es dauern?",
suggestedTimes_aa2e2b: "Empfohlene Zeiten",
noSlotFitsBeforeTheDueDate_8c442c: "Vor dem Fälligkeitsdatum passt kein Zeitfenster – die Arbeit benötigt mehr Zeit, einen anderen Verantwortlichen oder einen verschobenen Termin.",
howToRunIt_5809c8: "So führen Sie es aus",
endsOptional_92d6de: "Endet (optional)",
maxTimes_e58588: "Maximale Anzahl",
advanceTheSeries_2f1cf7: "Bringen Sie die Serie voran",
skipARunIfThePreviousOne_1b5907: "Den nächsten auslassen, wenn der letzte noch offen ist",
remindMe_25df3f: "Mich erinnern",
anythingTheInspectorShouldKnow_af9eeb: "Alles, was der Inspektor wissen sollte",
assignTo_cc7907: "Zuweisen an",
theContractorYouAwardOrHandThis_9cbde2: "Der Auftragnehmer, an den Sie diesen Auftrag vergeben oder übergeben. Die Auswahl hier weist ihn noch nicht zu – erst die Vergabe.",
checks_5098dd: "Prüfungen",
optionalAPrecheckConfirmsItIsSafe_db4e1f: "Optional. Eine Vorprüfung bestätigt, dass der Start sicher ist. Eine Nachkontrolle bestätigt die Arbeit vor der Abreise. Die hier hinzugefügten Prüfungen sind erforderlich, sodass der Arbeitsauftrag erst dann abgeschlossen werden kann, wenn sie abgeschlossen sind.",
analysingOnDevice_54be55: "Analyse auf dem Gerät…",
codes_199993: "Kennungen",
meterReadings_a3c12c: "Zählerstände",
dates_842b7b: "Termine",
detected_74fb2c: "Erkannt",
extractedText_5ea632: "Extrahierter Text",
noInformationWasExtractedOnDevice_80b803: "Es wurden keine Informationen auf dem Gerät extrahiert.",
enhancingWithAI_8078cd: "Verbesserung mit KI…",
aIEnhancementWillBeAvailableWhenYoure_ff5c7e: "Die KI-Verbesserung ist verfügbar, sobald Sie wieder online sind. Alles, was auf diesem Gerät gelesen wurde, ist gespeichert.",
summariseJourney_846b25: "Verlauf zusammenfassen",
loadedMatchesMoreAssetsAreAvailable_b38944: "{{value1}} Treffer geladen. Weitere Anlagen sind verfügbar.",
showing_6ec0cc: "Angezeigt: {{value1}}",
organisations_b83a9b: "Organisationen{{value1}}",
openJobs_31f2a1: "Offene Aufträge{{value1}}",
viewAll_f6220a: "Alle anzeigen · {{value1}}",
latest_a94fea: "Aktuell: {{value1}}",
previous_b3f133: "Vorher: {{value1}}",
risk_ad0435: "Risiko: {{value1}} ({{value2}})",
health_c90470: "Zustandswert: {{value1}} ({{value2}})",
compliance_49ba65: "Konformität: {{value1}} ({{value2}})",
confidenceReviewBeforeApplying_a8e435: "{{value1}} Konfidenz {{value2}}. Vor dem Anwenden prüfen.",
confidenceReviewBeforeApplying_050de9: "{{value1}} {{value2}} % Konfidenz. Vor dem Anwenden prüfen.",
itWillBeCreatedAsCommissionIt_d1903a: "Sie wird als {{value1}} angelegt. Nehmen Sie sie auf der Anlagenseite in Betrieb, sobald sie bereit ist — eine Inspektion, dann die daraus entstehenden Aufträge.",
upToPhotosOptionalTapThePreview_750506: "Bis zu {{value1}} Fotos — optional. Tippen Sie auf die Vorschau oder nutzen Sie die Schaltflächen unten.",
tapToAddAnother_f06704: "Tippen, um ein weiteres hinzuzufügen ({{value1}}/{{value2}})",
upToPhotosTotal_59c8b8: "Bis zu {{value1}} Fotos insgesamt",
headsUpAlreadyUsesThisIDSerial_108120: "Achtung: „{{value1}}“ verwendet diese ID / Seriennummer bereits.",
mo_8759d1: "{{value1}} Mon.",
upToPhotosOptionalSameAsWhen_a03894: "Bis zu {{value1}} Fotos (optional). Wie beim Anlegen einer Anlage — tippen Sie auf die Vorschau oder nutzen Sie Kamera / Galerie, um weitere hinzuzufügen.",
addAnotherPhoto_634f18: "Weiteres Foto hinzufügen ({{value1}}/{{value2}})",
groups_104467: "Gruppen: {{value1}}",
items_b74542: "Punkte: {{value1}}",
required_40bdfd: "Pflicht: {{value1}}",
conditionalRules_047d88: "Bedingte Regeln: {{value1}}",
currentVersionIsVSavingFromThis_07a9f2: "Aktuelle Version ist v{{value1}}. Speichern aus diesem Editor erstellt v{{value2}}.",
categories_5b1690: "Kategorien: {{value1}}",
depth_5fb610: "Tiefe: {{value1}}",
evidence_6674e1: "Nachweise: {{value1}}",
objectiveLengthChars_a7cb1d: "Länge der Zielsetzung: {{value1}} Zeichen",
runID_27348d: "Lauf-ID: {{value1}}",
estimatedDurationMin_a210a3: "Geschätzte Dauer: {{value1}} Min.",
responseDeadline_834634: "Antwortfrist: {{value1}}",
targetStart_cb37f8: "Geplanter Beginn: {{value1}}",
targetEnd_f9f809: "Geplantes Ende: {{value1}}",
estimatedBudget_070f47: "Geschätztes Budget: {{value1}} {{value2}}",
attachedPhotos_740082: "Angehängte Fotos · {{value1}}",
category_5e6549: "Kategorie: {{value1}}",
urgency_3bf5ac: "Dringlichkeit: {{value1}}",
dueDate_279007: "Fälligkeitsdatum: {{value1}}",
type_45c583: "Typ: {{value1}}",
pleaseRespondBy_ec61f2: "Bitte antworten Sie bis {{value1}}",
playVideo_dbbc47: "Video {{value1}} abspielen",
yourReason_882f62: "Ihr Grund: „{{value1}}“",
twofactorOfEnrolled_3402d7: "Zwei-Faktor: {{value1}} von {{value2}} eingerichtet",
currencyCommunication_43aa12: "Währung: {{value1}} · Kommunikation: {{value2}}",
errorsInView_5612eb: "Fehler in der Ansicht: {{value1}}",
when_f062b4: "Wann: {{value1}}",
locale_469d05: "Sprache: {{value1}}",
credits_ae86ee: "Credits: {{value1}} ({{value2}})",
entity_1fba91: "Entität: {{value1}}",
step_0d893e: "Schritt {{value1}}",
lastSuccessfulSyncLastFailedSyncNone_8b8bea: "Letzte erfolgreiche Synchronisierung: {{value1}} · Letzte fehlgeschlagene Synchronisierung: keine erfasst",
credentialSecretHiddenAfterCreationRotatedRevoked_326665: "Zugangsdaten: Secret nach Erstellung verborgen · rotiert {{value1}} · widerrufen {{value2}}",
status_ac4b0a: "Status: {{value1}}",
lastSuccessfulSync_d6b22a: "Letzte erfolgreiche Synchronisierung: {{value1}}",
lastFailedSync_e7a87b: "Letzte fehlgeschlagene Synchronisierung: {{value1}}",
logsHistory_117ea0: "Protokolle / Verlauf: {{value1}}",
suggested_bfc937: "Vorgeschlagen: {{value1}} · {{value2}} %",
row_69394c: "Zeile {{value1}}",
updated_3ada36: "Aktualisiert: {{value1}}",
newSitesCreated_a610d0: "Neue Standorte erstellt: {{value1}}",
skippedByConflictPolicy_e92870: "Durch Konfliktregel übersprungen: {{value1}}",
failed_1c734b: "Fehlgeschlagen: {{value1}}",
pOST_39bb77: "POST {{value1}}",
credentialTokenRotated_3254bf: "Zugangsdaten: {{value1}}-Token {{value2}}...{{value3}} · rotiert {{value4}}",
invocations_1e09a7: "{{value1}} Aufrufe",
lastSuccess_204f28: "Letzter Erfolg: {{value1}}",
lastFailure_fe19b0: "Letzter Fehlschlag: {{value1}}",
authTypeHeader_b1a0ff: "Auth-Typ: {{value1}}. Header: {{value2}}.",
secretState_e4463d: "Secret-Status: {{value1}}.",
request_65ee72: "Anfrage: {{value1}}",
response_7fff2f: "Antwort: {{value1}}",
statusRecentAssistantInvocations_a6c770: "Status: {{value1}} • letzte Assistentenaufrufe: {{value2}}",
lastInvocation_8b8558: "Letzter Aufruf: {{value1}}",
lastError_e74e5f: "Letzter Fehler: {{value1}}",
aHostedMCPEndpointForThisWorkspace_2ee242: "Ein gehosteter MCP-Endpunkt für diesen Arbeitsbereich: {{value1}}",
toolsAndResourcesEachFilteredByWorkspace_bdcaa8: "{{value1}} Werkzeuge und {{value2}} Ressourcen, jeweils nach Arbeitsbereich und Dienstkonto-Scopes gefiltert.",
reads_a89270: "Lesezugriffe: {{value1}}",
writes_532f15: "Schreibzugriffe: {{value1}}",
path_676484: "Pfad: {{value1}}",
scopes_993717: "Scopes: {{value1}} {{value2}}",
expiresCreated_8b46c7: "Läuft ab {{value1}} • erstellt {{value2}}",
preview_36c78a: "Vorschau: {{value1}}",
ms_588b6b: "{{value1}} ms • {{value2}}",
credits_05f92c: "{{value1}} Credits",
checks_05efc2: "{{value1}}{{value2}} % · {{value3}} Prüfungen",
dataQuality_984221: "{{value1}} · {{value2}} % Datenqualität",
reason_74bb8e: "Grund: {{value1}}",
showingRequestsFrom_dc8278: "Anfragen ab {{value1}} werden angezeigt.",
typeToConfirm_fac0ca: "Geben Sie {{value1}} zur Bestätigung ein",
lastCycles_9f5334: "Letzte {{value1}} Zyklen",
openWork_cc107a: "Offene Arbeit · {{value1}}",
tags_6e1f36: "Tags: {{value1}}",
team_fff0a5: "Team: {{value1}}",
compliance_89f882: "Konformität · {{value1}}",
registered_8b441e: "Erfasst {{value1}}",
ofCoreFieldsFilled_0f25e0: "{{value1}} von {{value2}} Kernfeldern ausgefüllt",
stillMissing_f3dd5e: "Fehlt noch: {{value1}}",
appliedReviewTheFieldsBelowTheySave_866743: "{{value1}} {{value2}} übernommen — prüfen Sie die Felder unten; sie werden automatisch gespeichert.",
poor_904815: "{{value1}} schlecht",
watch_a1d644: "{{value1}} unter Beobachtung",
good_aaf5c2: "{{value1}} gut",
unscored_e4e509: "{{value1}} nicht bewertet",
criticality_b7cd47: "Kritikalität {{value1}} · {{value2}}",
open_a1601a: "{{value1}} offene {{value2}}",
lastInspected_71de34: "Zuletzt inspiziert · {{value1}}",
rulesCalculated_3cece2: "Regeln {{value1}} · Berechnet {{value2}}",
likelihoodImpact_b6a9fb: "Wahrscheinlichkeit {{value1}} × Auswirkung {{value2}}",
"5Weight_d64551": "{{value1}}/5 · {{value2}} · {{value3}} % Gewichtung",
standaloneScoresBeforeLinkAdjustmentLI_1c934f: "Einzelwerte vor Verknüpfungsanpassung: W {{value1}} · A {{value2}}",
relationshipAdjustmentsAppliedLI_17818d: "Beziehungsanpassungen angewendet: W {{value1}}{{value2}} · A {{value3}}{{value4}}",
lRawRoundedIRawRounded_c4c6f6: "W roh {{value1}} → gerundet {{value2}}; A roh {{value3}} → gerundet {{value4}}",
rules_4b3591: "Regeln {{value1}}{{value2}}",
skipped_2fd804: "Übersprungen{{value1}}",
reportRef_4ee599: "Berichtsref.: {{value1}}",
completed_57e944: "Abgeschlossen {{value1}}",
round_6178c9: "Runde {{value1}} · {{value2}}",
firstShared_249645: "Erstmals geteilt {{value1}}{{value2}}",
dueBy_d51c85: "Fällig bis {{value1}}",
scheduledFor_37e8f3: "Geplant für {{value1}}",
confidence_615dda: "Konfidenz: {{value1}}",
useExtractedTotalAsActualCost_463a4f: "Extrahierte Summe{{value1}}{{value2}} als tatsächliche Kosten übernehmen",
fromQtyUnit_c1c1c3: "Aus Menge × Einheit: {{value1}}{{value2}}{{value3}}",
estimate_3a8133: "Schätzung: {{value1}}",
actual_e5762d: "Tatsächlich: {{value1}}",
vsEstimate_5939a7: "vs. Schätzung: {{value1}}{{value2}}{{value3}} ({{value4}}{{value5}} %)",
materialsSubtotal_f5bcb3: "Zwischensumme Material: {{value1}}{{value2}}",
inspected_517599: "Inspiziert {{value1}}",
theFullReportFindingsPhotosRecommendationsAnd_e1e094: "Der vollständige Bericht — Befunde, Fotos, Empfehlungen und etwaige Kosten — wird nur mit freigegebenen Personen geteilt. {{value1}}",
selected_deace8: "{{value1}} ausgewählt",
signedBy_06a094: "Unterzeichnet von {{value1}}",
tapSummariseJourneyToTryAgain_f327c1: "{{value1}} Tippen Sie auf „Verlauf zusammenfassen“, um es erneut zu versuchen.",
},
close: "Schließen",
back: "Zurück",
next: "Weiter",
detailTabs: {
  scrollForward: "Weitere Tabs anzeigen",
  scrollBack: "Vorherige Tabs anzeigen",
},
freePeriod: {
  until: "Kostenlos bis {{date}}. Wählen Sie einen Tarif, damit Ihr Workspace danach weiter funktioniert.",
  ended: "Ihr kostenloser Zeitraum ist abgelaufen und Ihr Workspace ist schreibgeschützt. Wählen Sie einen Tarif, um weiterzuarbeiten. Es wurde nichts gelöscht.",
},
aiReport: {
  link: "Melden",
  title: "Diese KI-Antwort melden",
  body: "Sagen Sie uns, was daran falsch ist. Wir speichern den angezeigten Text, um ihn zu prüfen.",
  offensive: "Anstößig",
  harmful: "Schädlich oder unsicher",
  wrong: "Falsch oder irreführend",
  cancel: "Abbrechen",
  sentTitle: "Meldung gesendet",
  sentBody: "Vielen Dank. Wir prüfen jede Meldung.",
  failedTitle: "Meldung konnte nicht gesendet werden",
},
collaboratorUpgrade: {
contractorTitle: "Eigene Aufträge und Kunden führen",
contractorBody: "Verwalten Sie Ihre eigenen Kunden, Aufträge und Rechnungen hier, mit eigenen KI-Guthaben. Ihre Arbeit für andere bleibt, wie sie ist.",
requesterTitle: "Eigenes Wartungsbuch führen",
requesterBody: "Behalten Sie Immobilien und Geräte, um die Sie sich selbst kümmern, mit Aufträgen, Prüfungen und Dokumenten im Blick. Was mit Ihnen geteilt ist, bleibt, wie es ist.",
recipientTitle: "Eigene Anlagen so prüfen",
recipientBody: "Führen Sie Prüfungen und Berichte wie diesen für Ihre eigenen Anlagen durch. Was mit Ihnen geteilt ist, bleibt, wie es ist.",
otherTitle: "Eigene Anlagen verwalten",
otherBody: "Richten Sie einen eigenen Arbeitsbereich für Ihre eigenen Anlagen und Arbeiten ein. Was Sie für andere tun, bleibt, wie es ist.",
cta: "Pläne ansehen",
freeReady: "Ihr Arbeitsbereich ist bereit. Fügen Sie Ihre erste Anlage über die Schaltfläche + hinzu.",
},
aiCost: {
included: "Von {{host}} bereitgestellt · noch {{n}} Guthaben diesen Monat",
includedUsed: "{{host}} stellt diesen Monat keine KI mehr bereit. Sie können Ihre eigenen Guthaben verwenden.",
  generateFailed: "Der Entwurf konnte nicht erstellt werden. Versuchen Sie es erneut oder erstellen Sie die Checkliste selbst.",
  buy: "Credits kaufen",
  onWeb: "Credits kaufen Sie bei AssetWRX im Web, oder sie kommen mit Ihren monatlichen Credits.",
  buyHint: "Kaufen Sie ein Credit-Paket, um fortzufahren, oder warten Sie auf Ihre monatlichen Credits.",
  askAdmin: "Bitten Sie den Inhaber oder einen Admin des Arbeitsbereichs, Credits zu kaufen, oder warten Sie auf Ihre monatlichen Credits.",
  askNamed: "Bitten Sie {{name}}, Credits zu kaufen, oder warten Sie auf Ihre monatlichen Credits.",
  shortUnknown: "Dafür sind nicht genug KI-Credits übrig.",
  short: "Nicht genug Credits: {{n}} nötig, {{balance}} übrig.",
  hint: "Verwendete KI-Credits: {{n}} · Verfügbar: {{balance}}",
},
aiGenerate: {
  discard: "Verwerfen",
  keep: "Behalten",
  discardBody: "Er wird nicht gespeichert. Sie können im Formular einen neuen erstellen.",
  discardTitle: "Diesen Entwurf verwerfen?",
  saveDraft: "Entwurf speichern",
  unsavedMessage: "Dein KI-Checklistenentwurf ist noch nicht gespeichert. Verlassen und verlieren?",
  leaveReviewTitle: "Prüfung verlassen?",
  savedTitle: "Checkliste gespeichert",
  feedbackFailedBody: "Feedback konnte nicht gespeichert werden. Die Checkliste wurde gespeichert.",
  goToTemplate: "Zur Checkliste",
  saveFailed: "Checkliste konnte nicht gespeichert werden.",
  leaveReviewBody: "Dein Entwurf wird nicht gespeichert. Verwirf ihn auf der Prüfseite, um Feedback zu hinterlassen.",
  stay: "Bleiben",
  moreOptionsSummary: "Dauer, Fotos, Reihenfolge und Stil",
  moreOptions: "Weitere Optionen",
  baseLabel: "Stil übernehmen von (optional)",
  goal: {
    fail_only_evidence: "Fotos nur bei Mängeln",
    physical_flow: "Die Reihenfolge beim Rundgang",
    compliance: "Einhaltung der Vorschriften",
  },
  goalLabel: "Zusätzlich ausrichten auf (optional)",
  evidence: {
    always: "Bei jedem Punkt",
    optional: "Wenn der Prüfer möchte",
    fail_only: "Nur wenn etwas durchfällt",
  },
  evidenceLabel: "Wann Fotos verlangt werden",
  depth: {
    detailed: "Gründlich",
    standard: "Normal",
    lite: "Schnelle Prüfung",
  },
  depthLabel: "Wie ausführlich",
  noAsset: "Keine bestimmte Anlage",
  basePlaceholder: "Checklisten-Checkliste wählen, deren Stil übernommen wird",
  baseSelected: "Ausgewählt",
  baseNone: "Keine",
},
aiDisclosure: {
title: "KI-Funktionen nutzen Google",
body: "AssetWRX sendet dafür die beteiligten Fotos und Texte an Google (Gemini). Google trainiert damit nicht. Beweisfotos, die Sie aus Vision übernehmen, können WRX Vision verbessern, sofern Ihr Workspace-Inhaber das nicht abschaltet. Details unter Profil → Datenschutz & Daten.",
allow: "Erlauben",
notNow: "Nicht jetzt",
declined: "KI wurde nicht verwendet. Sie können sie erlauben, wenn Sie das nächste Mal eine KI-Funktion nutzen.",
},
sessionExpiryBanner: {
expiresIn_one: "Ihre Sitzung läuft in {{count}} Minute ab.",
expiresIn_other: "Ihre Sitzung läuft in {{count}} Minuten ab.",
},
offlineStrip: {
offline: "Offline · Änderungen werden später synchronisiert",
offlineQueued_one: "Offline · {{count}} Änderung wartet",
offlineQueued_other: "Offline · {{count}} Änderungen warten",
syncing_one: "{{count}} Änderung wird synchronisiert…",
syncing_other: "{{count}} Änderungen werden synchronisiert…",
queued_one: "{{count}} Änderung wartet auf Synchronisierung",
queued_other: "{{count}} Änderungen warten auf Synchronisierung",
},
photoLimit: {
title: "Fotolimit erreicht",
body_one: "Sie können hier bis zu {{count}} Foto anhängen. Entfernen Sie eines, um ein weiteres hinzuzufügen.",
body_other: "Sie können hier bis zu {{count}} Fotos anhängen. Entfernen Sie eines, um ein weiteres hinzuzufügen.",
},
mapBoundary: {
start: "Tippen Sie auf die Ecken dieses Standorts",
more_one: "Tippen Sie auf mindestens {{count}} weitere Ecke",
more_other: "Tippen Sie auf mindestens {{count}} weitere Ecken",
adjust: "Ziehen Sie eine Ecke, um sie anzupassen, oder speichern Sie",
},
importSites: {
listSeparator: ", ",
moreNames_one: ", +{{count}} weiterer",
moreNames_other: ", +{{count}} weitere",
confirmTitle_one: "Bis zu {{count}} neuen Standort erstellen?",
confirmTitle_other: "Bis zu {{count}} neue Standorte erstellen?",
confirmBody_one: "Dieser Import erstellt bis zu {{count}} neuen Standort und verknüpft Anlagen damit:\n{{names}}{{more}}\n\nVorhandene Standorte werden wiederverwendet, wenn der Name übereinstimmt. Gehen Sie zurück und korrigieren Sie zuerst die Tabelle, falls darunter Duplikate oder Tippfehler sind.",
confirmBody_other: "Dieser Import erstellt bis zu {{count}} neue Standorte und verknüpft Anlagen damit:\n{{names}}{{more}}\n\nVorhandene Standorte werden wiederverwendet, wenn der Name übereinstimmt. Gehen Sie zurück und korrigieren Sie zuerst die Tabelle, falls darunter Duplikate oder Tippfehler sind.",
backToPreview: "Zurück zur Vorschau",
createAndImport: "Erstellen & importieren",
actionCreate: "erstellen",
actionUpdate: "aktualisieren",
actionSkip: "überspringen",
actionError: "Fehler",
calloutNew_one: "Bis zu {{count}} neuer Standort wird erstellt",
calloutNew_other: "Bis zu {{count}} neue Standorte werden erstellt",
calloutMatched: "Standorte nach Namen zugeordnet",
linkExisting_one: "Anlagen werden mit {{count}} vorhandenen, nach Namen zugeordneten Standort verknüpft.",
linkExisting_other: "Anlagen werden mit {{count}} vorhandenen, nach Namen zugeordneten Standorten verknüpft.",
matchedCaseInsensitive: "Namen werden vorhandenen Standorten zugeordnet (Groß- und Kleinschreibung wird ignoriert).",
reuseNote: " Vorhandene Standorte werden wiederverwendet, wenn der Name übereinstimmt — neue Standorte bestätigen Sie vor dem Import.",
},
attachmentsPanel: {
title: "Anhänge",
all: "Alle",
empty: "Noch nichts angehängt.",
kind: { photo: "Fotos", video: "Videos", audio: "Sprache", document: "Dateien" },
source: {
fallback: "Anhang",
"job.completion_photo": "Abschlussfoto",
"job.completion_video": "Abschlussvideo",
"job.completion_voice_note": "Sprachnotiz zum Abschluss",
"job.receipt": "Beleg",
"job.activity_attachment": "Anhang aus dem Verlauf",
"inspection.item_photo": "Inspektionsfoto",
"inspection.item_video": "Inspektionsvideo",
"inspection.item_voice_note": "Sprachnotiz zur Inspektion",
},
},
};
